import { add } from "@/api/Strategy";
import { start } from "nprogress";

export default {
  language: '中文',
  switchlangtip: '语言切换成功',
  nav: {
    // app.vue左侧导航栏
    singeltest: '单次呼叫测试',
    ai_call: '呼叫管理',
    calling_operation: 'Calling运营',
    robot: '机器人管理',
    black_list: '黑名单',
    robot_list: '机器人列表',
    add_call: 'Add Call',
    systemsettings: '系统设置',
    accountmanagement: '账户管理',
    corporateaccountinformation: '企业账户信息',
    usermanagement: '用户管理',
    functionrightsrole: '角色权限管理',
    dashboard: '仪表盘',
    promote: '营销',
    callcenter: '呼叫中心',
    executecall: '呼叫任务',
    detailsofcall: '通话明细',
    reportstatistics: '报表统计',
    overallreportstatistics: '整体报表统计',
    speechreportstatistics: '话术报表统计',
    accountreportstatistics: '账号报表统计',
    robotreportstatistics: '机器人报表统计',
    archivingcenter: '归档中心',
    historicaltaskrecord: '历史任务记录',
    historicalcalllog: '历史通话记录',
    detailsofcharges: '费用明细',
    testcall: '测试呼叫任务',
    guide: '查看引导',
    strategy: '呼叫策略',
    plan: '计划任务',
    auditInformation: '信审呼叫任务',
    PDetails: 'PDetails',
    PStrategy: 'PStrategy',
    PPlans: 'PPlans',
    ICDetail: '信审详情',
    ICStrategy: '信审呼叫策略',
    ICPlan: '信审计划任务',
    accessControl: '访问控制'
  },
  global: {
    date: '请选择日期',
    taskNameSelector: {
      selectLabel: '任务选择',
      selectTask: '请选择任务名称',
      selectTest: '请选择测试任务名称',
      allSelect: '选择全部任务',
      selectWarn: '请至少选择一个任务再进行查询'
    },
    planNameSelector: {
      selectLabel: '计划',
      selectTask: '请选择计划名称',
      selectTest: '请选择测试计划名称',
      allSelect: '选择全部计划',
      selectWarn: '请至少至少一个任务之后再进行查询'
    },
    distinctSelector: {
      label: '去重标签',
      placeholder: '请选择去重标签'
    },
    select: '请选择',
    // filter: '搜索',
    MarketingA: 'A: 有意愿',
    MarketingB: 'B: 无意愿',
    query: '查询',
    filter: '筛选条件',
    today: '今天',
    yesterday: '昨天',
    nearly_three_day: '近3天',
    nearly_seven_day: '近7天',
    nearly_thirty_day: '近30天',
    nearly_days: '近{num}天',
    startTime: '开始日期',
    endTime: '结束日期'
  },
  menuNode: {
    CallTasks: '呼叫任务',
    CallPlans: '呼叫计划',
    CallStrategy: '呼叫策略',
    CallDetails: '通话明细',
    ICDetail: '信审详情',
    BlackList: '黑名单',
    RobotList: '机器人列表',
    SingleTest: '单次呼叫测试',
    AddCall: '加拨',
    Corporate: '企业账户信息',
    UserControl: '用户管理',
    RolePermission: '角色权限管理',
    Dashboard: '仪表盘',
    AiCalling: '呼叫管理',
    RobotManage: '机器人管理',
    CallingOperation: 'Calling运营',
    Inbound: '呼入',
    AccountManage: '账户管理',
    personalInfo: '个人信息',
    systemsettings: '系统设置',
    collection: '催收业务',
    marketing: '营销业务',
    info_check: '信审业务',
    outbound: '智能机器人',
    operationOutbound: '运营外呼',
    pack_up_menu: '收起菜单',
    switch_old_version: '切换旧版',
    switch_new_version: '切换新版',
    prompt_cannot_used: '您的账号是在新版创建的，不能使用旧版哦',
    personalSetting: '个人设置',
    loginInfo: '登录信息',
    template: '体验版',
    RobotExperience: '机器人体验',
    servise_tools: '服务与工具',
    helpCenter: '帮助中心',
    OperatingRecord: '操作记录',
    CallAssistant: '呼叫助手',
    releaseNotes: '版本记录',
    cod: '电商业务',
    WorkflowManage: 'Workflow管理',
    WorkflowManger: 'Workflow管理',
    WorkflowTemplate: 'Workflow模板',
    Workflow: 'Workflow任务',
    SmsTemplate: '短信模板管理',
    WhatsappTemplate: 'WhatsApp模板管理',
    MultiChannelManager: '多渠道管理',
    StageReport: '阶段报告',
    CrossLogin: '穿越登录',
    manual: '操作手册',
    document: 'API文档',
    add: '添加',
    info: '查看详情',
    copy: '复制',
    edit: '编辑',
    child: '查看子任务',
    check: '查看进度',
    view: '数据总览',
    editRole: '编辑角色',
    addRole: '新增角色',
    version: '版本管理',
    batchShare: '批量分享',
    shareLog: '分享记录',
    viewData: '查看数据',
    Application: '应用市场',
    view_number: '查看电话号码',
    CallDetailAudioDownload: '明细下载录音',
    TaskDetailAudioDownload: '任务详情下载录音',
    PlanViewAudioDownload: '计划下载录音',
    ViewCallDetail: '查看对话',
    Tools: '服务与工具',
    WorkflowVersion: '版本管理',
    WorkflowDashboard: '数据总览',
    CallLog: '通话记录',
    chatbot: 'Chatbot',
    ChatbotOverview: '数据概览',
    ChatbotLiveMonitor: '实时视图',
    ChatbotAnalysis: '机器人分析',
    ChatbotCR: '会话记录',
    ChatbotSocial: '消息渠道',
    ChatbotManage: '机器人管理',
    ChatbotOnline: '机器人上线',
    ChatbotReq: '请求信息',
    ChatbotWBTmpl: 'WA模版管理',
    ChatbotWBTmplDetail: '模版详情',
    ChatbotWBTmplAdd: '新增模版',
    ChatbotWBTmplEdit: '编辑模版',
    ChatbotChat: '聊天',
    ChatbotTeamInbox: '在线聊天',
    ChatbotMAB: '广播营销',
    ChatbotBroadcast: '广播列表',
    ChatbotGeneral: '通用',
    ChatbotAPI: 'API文档',
    ChatbotOptOut: 'Opt-out列表',
    InboundRobotManage: '机器人管理',
    InboundDashboard: 'Dashboard',
    InboundCallRecords: '通话记录',
    timeTip: '仅支持在线查询最近6个月的数据',
    timeTip2: '仅支持在线查询2024年3月1日起的最近6个月数据',
    workflowTip: '此方式仅支持查询2024年2月1日之后产生的数据',
    configCenter: '控制中心',
    accessControl: '访问控制',
    holiday: '日历管理',
    Insights: '仪盘表',
    ChatbotInsightsLiveMonitor: '实时视图'
  },
  account: {
    // 账户管理
    account_time_zone_new: '账户地区与时区',
    cod: '电商业务',
    template: '体验版',
    administrator: '管理员',
    enterprise: '所属企业',
    account_title: '账户名称',
    account_country: '账户国家',
    account_time_zone: '账户时区',
    account_id: '账户ID',
    corporate_contacts: '企业联系人',
    contact: '联系人',
    email: '邮箱',
    phone: '电话',
    gender: '性别',
    male: '男',
    female: '女',
    user_group: '用户分组',
    add_uer: '新增用户',
    edit_uer: '编辑用户',
    edit_group: '编辑分组',
    add_group: '新增分组',
    group_name: '分组名称',
    user_name: '姓名',
    first_name: '名字',
    last_name: '姓',
    account_number: '登录账号',
    password: '密码',
    initial_password: '初始密码',
    roleId: 'Role ID',
    lastLoginTime: '最后登录时间',
    group: '分组',
    role: '角色',
    edit: '编辑',
    added: '新增',
    enable: '启用',
    disable: '停用',
    save: '保存',
    reset_passwords: '重置密码',
    new_login_password: '新登录密码',
    set_new_login_password: '设置新登录密码',
    error_user_tip: '检测到您的账号存在风险，为了您的账户安全，请重置您的登录密码',
    new_user_tip: '为了您的账户安全，请先重置您的登录密码',
    confirm_password: '确认密码',
    add_role: '新增角色',
    edit_role: '编辑角色',
    role_name: '角色名称',
    role_describe: '角色描述',
    actions: '操作',
    status: '状态',
    delete: '删除',
    basic_information: '基础信息',
    business_type: '业务类型',
    data_permission: '数据权限',
    fnction_permissions: '功能权限',
    collection: '催收',
    marketing: '营销',
    info_check: '信审',
    CallingOperation: 'Calling运营',
    chatbot: 'Chatbot',
    select_all: '全选',
    clear: '清空',
    all: '全部',
    prompt_account_name: '请输入账号、姓名',
    prompt_password_again: '请再次输入密码',
    prompt_role_description: '请输入角色描述',
    prompt_first_name: '请输入姓名',
    prompt_last_name: '请输入姓',
    prompt_login: '请输入登录账号',
    prompt_password: '由数字、大写、小写字母组成的8-16位密码',
    prompt_logo: '支持上传 jpg/jpeg/png/gif 格式，大小不超过 5M的图片',
    prompt_group: '请选择分组',
    prompt_role: '请选择角色',
    prompt_role_name: '请输入角色名称',
    prompt_delete_role: '该角色已关联用户，无法删除',
    error_logo_type: '仅支持jpg/jpeg/png/gif格式图片',
    error_logo_size: 'LOGO大小不能超过5M',
    error_cannot_exceed_200: '不能超过200字符',
    error_cannot_exceed_100: '不能超过100字符',
    error_cannot_exceed_50: '不能超过50字符',
    error_cannot_exceed_20: '不能超过20字符',
    error_group: '该分组下已有用户，无法删除',
    error_group_size: '不能超过50个分组',
    error_login: '登录账号不能为空',
    error_login_exis: '该登录账号已存在',
    error_password: '密码需为8-16位，且包括数字、大写和小写字母',
    error_password_different: '2次输入密码不一致',
    error_group_name: '分组名称不能重复',
    error_enable: '启用状态的用户数量不能超过{xxx}',
    error_role_name: '角色名称不能为空',
    error_business_type: '业务类型不能为空',
    error_first_name: '名字不能为空',
    error_last_name: '姓不能为空',
    error_enter_group_name: '分组名称不能为空',
    error_new_login_password: '新登录密码不能为空',
    error_confirm_password: '确认密码不能为空',
    permission_list: {
      view: '查看',
      add: '添加',
      edit: '编辑',
      start: '开始',
      delete: '删除',
      pause: '暂停/恢复',
      cancel: '取消',
      download: '下载',
      copy: '复制',
      enable: '启用',
      disable: '停用',
      ableOrNot: '停用/启用',
      viewShield: '查看屏蔽数据',
      allocation: '分配',
      download_task: '下载任务',
      download_roll: '下载名单',
      download_detail: '下载明细',
      password: '重置密码',
      apply: '应用',
      edit_remark: '编辑备注',
      edit_name: '修改模板名称',
      download_subtask: '下载子任务记录',
      view_subtask_detail: '查看子任务明细',
      view_subtask: '查看子任务',
      add_detail: '新增名单',
      workflowProgress: '查看进度',
      triggerImmediately: '立即触发',
      categorize: '事件标签分组',
      restore: '还原',
      archive: '归档',
      active: '启用',
      edit_description: '编辑描述',
      view_versions: '查看版本管理',
      RobotExperience: '机器人体验',
      StageReport: '阶段报告',
      CrossLogin: '穿越登录',
      MultiChannelManager: '多渠道管理',
      releaseNotes: '版本记录',
      operateWord: '操作手册',
      apiWord: 'API文档',
      OperatingRecord: '操作记录',
      Application: '应用市场',
      selectCountry: '选择国家',
      processProportion: '机器人各流程通话量占比',
      labelDistribution: '机器人标签分布',
      transRateTrends: '通话量及转人工率趋势',
      transCauseDistribution: '转人工原因分布',
      nodeDistribution: '转人工节点分布',
      effectKnowledge: '有效知识占比',
      knowledgeHitRatio: '知识命中率',
      hotKnowledge: 'Top10热门知识',
      unpopularKnowledge: 'Top20冷门知识',
      callDimension: '通话维度',
      callStatics: '数据总览',
      robotCalls: '总通话量',
      robotCallsProgress: '机器人通话中数',
      successfulTransferRate: '成功转人工率',
      arCallDuration: '机器人平均通话时长',
      arInteractionRounds: '机器人平均交互轮次',
      agentCalls: '人工通话量',
      agentCallsProgress: '人工通话中数',
      aTransferRate: '尝试转人工率',
      taCallDuration: '总平均通话时长',
      knowledgeDimension: '知识点维度',
      downRecording: '下载录音',
      downRecord: '下载记录',
      download_task_detail_plain_text_phone: '明文下载通话明细数据',
      download_upload_excel_plain_text_phone: '下载明文客户上传excel',
      approvalAddTask: '审批-添加任务',
      approvalDownloadList: '审批-下载名单',
      approvalApprove: '审批-审批',
      download_plan_detail_plain_text_phone: '计划下载明文明细',
      approvalAddPlan: '审批-添加计划',
      approvalDownloadPlanList: '审批-下载名单',
      approvalPlanApprove: '审批-审批',
      CallDetailAudioDownload: '通话明细录音下载',
      TaskDetailAudioDownload: 'TaskDetailAudioDownload',
      PlanViewAudioDownload: 'PlanViewAudioDownload',
      ViewCallDetail: '查看对话',
      Dashboard: '仪表盘',
      AccountManage: '账户管理',
      ModifyTimeZone: '修改时区',
      Corporate: '企业账户信息',
      UserControl: '用户控制',
      RolePermission: '角色权限',
      AiCalling: '呼叫管理',
      CallTasks: '呼叫任务',
      download_task_detail_plain_text_phone: '下载明文明细',
      download_upload_excel_plain_text_phone: '下载明文客户上传excel',
      CallPlans: '呼叫计划',
      download_plan_detail_plain_text_phone: '计划下载明文明细',
      CallStrategy: '呼叫策略',
      CallDetails: '通话明细',
      CallDetailAudioDownload: 'CallDetailAudioDownload',
      download_plain_text_phone: '下载明文明细',
      transferOrNot: '是否转人工',
      BlackList: '黑名单',
      download_blacklist_plain_text_phone: '下载明文黑名单',
      CallAssistant: '呼叫助手',
      RobotManage: '机器人管理页面',
      RobotList: '机器人列表',
      addMessage: '新增挂机短信',
      deleteMessage: '删除挂机短信',
      editMessage: '编辑挂机短信',
      messageStatus: '挂机短信状态',
      viewHangUpMessage: '挂机详情查看',
      WorkflowManger: 'Workflow管理',
      WorkflowDashboard: 'Workflow Dashboard',
      WorkflowDashboardPage: 'WorkflowDashboard页面',
      uploadList: '上传名单数',
      singularName: '去重名单数',
      numberDelisting: '取消名单数',
      WorkflowDashboard: '更新名单数',
      numberWorkflowTasks: '创建workflow任务数',
      workflowTasksExecution: '执行中workflow任务数',
      uploadListNumberTrend: '上传名单数趋势',
      callsInList: '总拨打名单数',
      redialListNumber: '去重拨打名单数',
      numberDeconnecting: '去重接通名单数',
      disconnectionRate: '去重接通率',
      totalNumberCalls: '总拨打轮次数',
      totalNumberRounds: '总接通轮次数',
      totalConnectionRate: '总接通率',
      AverageConnectedCalls: '接通电话平均拨打轮次数',
      averageNumberCalls: '平均拨打次数',
      onAverageNumberCalls: '接通电话平均拨打次数',
      averageCallDuration: '平均通话时长',
      averageInteractiveRounds: '平均交互轮次',
      averageRingingDuration: '平均响铃时长',
      tryTurnLaborNumber: '尝试转人工数',
      attemptTransferLaborRate: '尝试转人工率',
      numberSuccessfulTransfers: '成功转人工数',
      successRateTransfer: '转人工成功率',
      robotSearch: '机器人搜索',
      platformSearch: 'platform搜索',
      downloadData: '下载数据',
      trendNumberCallsList: '拨打名单数趋势',
      labelDistributionTrend: '标签分布趋势',
      connectionRateTrend: '接通率趋势',
      callDurationDistribution: '通话时长分布',
      callDurationDistributionTrend: '通话时长分布趋势',
      ringClassification: '响铃分类',
      hangUpSort: '挂断分类',
      trendLaborTransferRate: '转人工率趋势',
      outboundCall: 'Outbound call',
      sms: 'SMS',
      waMessage: 'WA Message',
      pds: 'PDS',
      waTemplate: 'WA Template',
      shortMessagesSent: '短信发送总名单数',
      smsSingularName: '短信发送去重名单数',
      goTo7DayHits: '去重7日点击数',
      goClickThroughRate: '去重点击率',
      totalNumberTransmissions: '总发送数',
      total7DayHits: '总7日点击数',
      clickRate: '点击率',
      averageNumberTransmissions: '平均发送次数',
      trendNumberShortMessage: '短信发送名单数趋势',
      clickRateTrend: '点击率趋势',
      waSmsSingularName: 'wa短信发送去重名单数',
      waGoTo7DayHits: 'wa去重7日点击数',
      waGoClickThroughRate: 'wa去重点击率',
      waTotalNumberTransmissions: 'wa总发送数',
      waTotal7DayHits: 'wa总7日点击数',
      waClickRate: 'wa点击率',
      waAverageNumberTransmissions: 'wa平均发送次数',
      waTrendNumberShortMessage: 'wa短信发送名单数趋势',
      waClickRateTrend: 'wa点击率趋势',
      waShortMessagesSent: 'wa短信发送总名单数',
      numberPdsList: 'PDS名单数',
      pdsSingularName: 'PDS去重名单数',
      trendPdsListNumber: 'PDS名单数趋势',
      waTemplateTotalNumber: 'WA Template发送总名单数',
      waTemplateSingularName: 'WA Template发送去重名单数',
      wtTotalNumberTransmissions: 'wt总发送数',
      wtAverageNumberTransmissions: 'wt平均发送次数',
      waTemplateIndicates: 'WA Template发送名单数趋势',
      sendNumberTrend: '发送数趋势',
      deliveryNumber: '短信送达数',
      successTransmissions: '短信发送成功数',
      successResending: '去重发送成功数',
      waDeliveryNumber: 'wa送达数',
      waSuccessTransmissions: 'wa发送成功数',
      waSuccessResending: 'wa去重发送成功数',
      WorkflowTemplate: 'Workflow模版',
      custom_components: '自定义组件',
      holiday: '日历管理',
      Workflow: 'Workflow任务',
      download_workflow_detail_plain_text_phone: '下载子任务明文明细',
      viewDashboard: '数据总览',
      WorkflowVersion: 'WorkflowVersion',
      archive_rows: '查看归档按钮列表',
      WorkflowComponents: 'Workflow组件',
      time: 'time',
      manual: 'manual',
      slot: 'slot',
      user_latest_intention: 'user_latest_intention',
      customized_attributes: 'customized_attributes',
      splitter: 'splitter',
      url_click: 'url_click',
      combination: 'combination',
      voicebot_call: 'voicebot_call',
      voicebot_agent_call: 'voicebot_agent_call',
      pds_call: 'pds_call',
      sms: 'sms',
      wa_message: 'wa_message',
      api: 'api',
      voicebot_kit: 'voicebot_kit',
      holiday: 'holiday',
      mail: 'mail',
      PDSConfig: 'PDS配置',
      voicemail: '语音信箱',
      qa: '质检开关',
      contactNumberInterval: '联系方式呼叫间隔',
      SmsTemplate: 'Sms模版',
      create: '新增短信模板',
      status: '模板状态',
      WhatsappTemplate: 'Whatsapp模版',
      create: '新增',
      status: '状态',
      Tools: '服务与工具',
      personalSetting: '个人设置',
      personalInfo: '个人信息',
      avatar: '修改头像',
      email: '换绑邮箱',
      loginInfo: '登录信息',
      '2FA': '2FA',
      view_number: '查看电话号码',
      viewNumber: '查看电话号码',
      timeZone: '修改时区',
      contact: '企业联系人展示',
      approvalBack: '审批-撤回',
      approvalPlanBack: '审批-撤回',
      ringSorts: '响铃分类',
      updateListNumber: '更新名单数',
      configCenter: '控制中心',
      accessControl: '访问控制'
    },
    disabled: '已停用',
    enabled: '已启用',
    user_table: '用户列表',
    role_table: '角色列表',
    Inbound: '呼入',
    resMust: '请至少选择一个权限'
  },
  dashboard: {
    // lxl 2021-07-22 修改
    // noData: '暂无数据',
    noData: '未找到相关结果',
    // overview: '关键数据',
    overviewDescription: '这里主要用于显示拨打任务的统计结果。',
    // overviewDescription: '表示数据仍在计算中，每日12点左右产出昨日数量。',
    totalNumOfCalls: '总名单数量(个)',
    durationOfCall: '通话时长(秒)',
    avDurationOfCalls: '平均通话时长(秒)',
    reachedNum: '接通数(个)',
    totalCost: '总花费',
    averageCost: '平均花费',
    reachedRateOfCall: '接通成功率',
    // intentions of customers
    customerIntention: '客户意向标签数据占比',
    customerIntention_distinct: '客户意向标签数据占比 (按姓名去重)',
    reachedRate_distinct: '接通率 (按姓名去重)',
    total_customer_distinct: '客户总数',
    total_reached_distinct: '总接通数',
    // duration of calls
    durationOfCalls: '通话时长数量显示',
    callLength: '通话时长',
    number: '数量(个)',
    // duration: '时长(s)',
    overallResult: '信审结果',
    comingSoon: '更多功能，敬请期待',
    // dashboard 底部table
    table: {
      taskName: '任务名称',
      totalCost: '总花费',
      total: '总名单数量',
      unreached: '未接通数',
      reached: '接通数',
      successRate: '接通成功率',
      totalDuration: '总时长(秒)',
      average: '平均通话时长(秒)',
      intention: '意向标签'
    },
    viewDataTip: '请联系客户经理查看更多数据',
    plans: '计划数',
    tasks: '任务数',
    calling_tasks: '正在呼叫任务',
    pending_tasks: '待执行任务',
    // lxl 2021-07-22 修改
    //total_callee: '总名单数（个）',
    // reached_rate: '接通率'
    // average_call_duration: '平均通话时长',
    total_callee: '全部名单个数',
    reached_rate: '电话接通率',
    average_call_duration: '平均电话通话时长',
    average_call_waiting_duration: '平均呼叫等待时长',
    today: '今天',
    last_three_day: '近三天',
    last_seven_day: '近七天',
    overview: '数据概览',
    call_analysis: '呼叫分析',
    // lxl 2021-07-22 修改
    // vdoing: '统计维度',
    vdoing: '时间区间',
    khyxzb: '客户意向占比',
    xsjgfb: '信审结果分布',
    callTime: '通话时长',
    ringType: '响铃分类',
    nocallType: '挂断分类',
    callTrend: '接通率趋势',
    byHour: '按小时',
    byDay: '按天',
    allTrend: '各意向趋势',
    icResult: '信审结果趋势',
    duration: '平均通话时长',
    average_time: '平均呼叫等待时长',
    tasklist: '任务列表',
    total_types: '全部分类',
    all: '全部',
    all_task: '全部任务',
    all_robot: '全部机器人',
    all_results: '全部结果',
    all_trends: '全部意向',
    shuliang: '数量/个',
    shichang: '时长/秒',
    unduplicated: '去重',
    duplicate: '不去重',
    totalTrend: '总结果',
    everyCallTime: '每日呼叫时长',
    totalNumber: '总名单数',
    totalCallNumber: '总接通数',
    totalCallRate: '总接通率',
    noConnectedNumber: '未接通数',
    tocallNumber: '外呼数',
    max_day_data: '最多可选择31天的数据',
    by_task: '按任务',
    by_robot: '按机器人',
    plans_tooltip: '开始时间在筛选时间范围内的计划数',
    taks_tooltip: '开始时间在筛选时间范围内的任务数',
    calling_tasks_tooltip: '筛选时间范围内，正在呼叫的任务数量',
    pending_tasks_tooltip: '筛选时间范围内，待执行的任务数量',
    total_callee_tooltip: '筛选条件下，拨打的总名单数',
    reached_rate_tooltip: '筛选条件下，拨打电话的接通率',
    average_call_duration_tooltip: '筛选条件下，接通电话的平均通话时长',
    average_call_waiting_duration_tooltip: '筛选条件下，全部拨打电话的平均呼叫等待时长',
    khyxzb_hover_explain: '（1）筛选条件下，全部通话标签的分布情况 \n（2）去重规则：根据手机号去重',
    callTime_hover_explain: '筛选条件下，通话时长的分布情况',
    ringType_hover_explain: '筛选条件下，全部通话的响铃分布',
    nocallType_hover_explain: '筛选条件下，全部通话的挂断分类',
    call_tip_filter_rule: '（1）统计筛选条件下，每天的接通率趋势 \n（2）去重规则：根据手机号去重',
    trend_tip: '筛选条件下，各个通话标签每天的趋势',
    duration_tip: '筛选条件下，每天的平均通话时长趋势',
    average_time_tip: '筛选条件下，每天的平均呼叫等待时长趋势',
    tasklist_tip: '筛选条件下，各个任务的通话数据情况',
    connect_number_tooltip: '筛选条件下，所有已接通的电话数量',
    all_talk_time_tooltip: '筛选条件下，所有已接通电话的通话时长之和',
    // lxl 2021-07-22 修改
    //connect_number: '接通数',
    //all_talk_time: '总通话时长',
    connect_number: '已接通电话数量',
    all_talk_time: '已接通电话总时长',
    dimension: '去重维度'
  },
  workbenchtable: {
    // 首页表格
    total: '拨打数',
    unreached: '未接通数',
    reached: '接通数',
    successrate: '接通率',
    totalduration: '总时长(秒)',
    average: '平均通话时长(秒)'
  },
  taskPlan: {
    tpDone: '已审批',
    tpWati: '待审批',
    tpReject: '已拒绝',
    tpBack: '已撤回',
    tpCreated: '已创建',
    wait: '任务信息已提交，请等待审批',
    planWait: '计划信息已提交，请等待审批',
    approveTime: '审批时间',
    creator: '创建人',
    taskStatus: '任务状态',
    planStatus: '计划状态',
    approve: '审批',
    back: '撤回',
    dlList: '下载名单',
    pass: '通过',
    noPass: '不通过',
    confirmBack: '确认撤回吗？',
    approvalOK: '审批通过，任务名{name}',
    approvalNO: '审批不通过，任务名{name}',
    planOK: '审批通过，计划名{name}',
    planNO: '审批不通过，计划名{name}',
    taskBack: '撤回任务{name}',
    planBack: '撤回计划{name}',
    planTime: '计划日期',
    goApprove: '去审批'
  },
  execall: {
    // executecall.vue和executecallTable和exetestForm中数据
    taskCheck: '呼叫任务执行时间需长于重拨间隔*重拨次数',
    strategyCheck: '策略时间需长于重拨间隔*重拨次数',
    task: '任务',
    DueDate: '到期日',
    genderselect: '性别',
    BorrowerName: '借款人姓名',
    BorrowedAmount: '借款金额',
    BorrowedDate: '借款日期',
    TotalOwingAmount: '总计',
    platName: '平台名称',
    finished: '已完成',
    executecall: '执行呼叫',
    taskname: '任务名称',
    testname: '任务名称',
    voicetemplate: '语音模板',
    calltime: '呼叫时间',
    endtime: '结束时间',
    addtasks: '添加呼叫任务',
    addstrategy: '添加策略',
    editstrategy: '修改策略',
    testcall: '测试呼叫',
    successimport: '成功导入数',
    updatetime: '更新时间',
    createtime: '创建时间',
    starttime: '开始时间',
    callstate: '呼叫状态',
    operation: '操作',
    searchinfo: '信息查询',
    Filepath: '文件路径',
    DownLoad: '下载',
    resume: '恢复',
    cancel: '取消',
    source: '来源',
    details: '明细',
    pause: '暂停',
    start: '开始',
    progress: '进度',
    submit: '提交',
    utcselect: '时区选择',
    templatselect: '语音模板',
    routeselect: '线路选择',
    upload: '呼叫联系人上传数据',
    expired: '过期作废',
    recall: '是否重拨',
    timeselect: '时间选择',
    // lxl 2021-07-22 修改
    // starttimeselect: '开始时间',
    // endtimeselect: '结束时间',
    starttimeselect: '任务开始时间',
    endtimeselect: '任务结束时间',
    downtemplate: '下载模板样例',
    yes: '是',
    no: '否',
    // lxl 2021-07-22 修改
    // interval: '重拨间隔(分钟)',
    // maxnumrecall: '重拨数（不含首次）',
    interval: '重拨时间间隔(分钟)',
    maxnumrecall: '重拨次数',
    reset: '重置',
    createdtimerange: '选择创建时间',
    createdtimeto: '选择创建时间',
    // lxl 2021-07-22 修改
    // tianjia_task: '添加任务',
    tianjia_task: '创建任务',

    addplan: '添加计划',
    planname: '计划名称',
    calling_strategy: '调用策略',
    sip: '线路',
    actions: '操作',
    date: '日期',
    strategy: '呼叫策略',
    view: '查看',
    calleeNumber: '被叫号码',
    calltimerange: '呼叫时间',
    save: '保存',
    addTask: '添加外呼任务',
    importNames: '导入名单',
    checkNames: '名单校验',
    over: '完成',
    input_names: '请上传名单',
    download_fillin: '下载模板并按照格式填写',
    already_list: '上传填写好的名单',
    xiazai_template: '下载模板',
    upload_names: '上传名单',
    select_drug: '选择或拖拽文件到此区域上传',
    // lxl 2021-07-22 修改
    //error_words: '确认忽略错误数据，根据成功导入的名单创建任务？',
    error_words: '是否确定忽略导入失败的数据，以导入成功的数据继续创建任务？',
    ten_data: '当前仅展示10条内数据，详细信息请',
    total_error_data: ' 下载全部失败数据',
    reject_number: '导入名单将剔除黑名单号码',
    // lxl 2021-07-22 修改
    // fail_list: '失败列表',
    fail_list: '导入失败数据列表',
    error_content: '错误内容',
    renwu_list: '任务列表',
    line: '行数',
    // lxl 2021-07-22 修改
    //all_numbers: '总名单量',
    all_numbers: '名单总数',
    success: '成功',
    // lxl 2021-07-22 修改
    //fail: '失败',
    fail: '失败名单数',
    add_plans: '添加呼叫计划',
    plan_name: '计划名称',
    check_plan: '查看计划',
    set_plan: '设置外呼计划',
    round: '当前轮次',
    reupload: '重新上传',
    import_result: '导入结果',
    // lxl 2021-07-22 修改
    // add_success: '任务添加成功',
    add_success: '新任务创建成功',
    setDialTime: '请稍等，电话将在您设定的拨打时间拨出',
    countdown: '{number}秒后自动收起该页面',
    pre_step: '上一步',
    next_step: '下一步',
    create_task: '创建任务',
    project_list: '计划列表',
    gap_times: '重拨数',
    gap: '重拨间隔',
    viewRobotIntr: '查看机器人介绍',
    robotIntr: '机器人介绍',
    setOutboundCallPlan: '设置外呼任务',
    selectStartTime: '请先选择开始时间',
    distance: '距离开始时间',
    halfHour: '0.5小时',
    oneHour: '1小时',
    oneHalfHour: '1.5小时',
    twoHours: '2小时',
    timeHorizon: '请选择6:00-22:00范围内的时间',
    totalCount: '总拨打名单数',
    uploadCount: '上传名单数',
    distinctReachRate: '去重接通率',
    allstrategy: '全部策略',
    allplan: '全部计划',
    searchTip: '此方式仅支持查询2023年4月14日之后产生的通话数据',
    day5Error: '开始和结束时间均不能晚于当天日期的第5天',
    fileSuccess: '文件上传成功'
  },
  accessControl: {
    ipBlack: 'IP黑名单',
    ipWhite: 'IP白名单',
    currentIP: '当前的IP黑名单仅对客户通过API接口进行访问的场景生效。',
    currentIP2: '当前的IP白名单仅对客户通过API接口进行访问的场景生效。',
    delIP: '删除IP地址',
    addIP: '添加IP地址',
    ipAdd: 'IP地址',
    addBlack: '添加黑名单',
    addWhite: '添加白名单',
    editBlack: '编辑黑名单',
    editWhite: '编辑白名单',
    ipTip: `支持任意IP地址，例如10.0.0.10或FF05.:B5;支持CIDR格式地址，例如10.0.0.0/16或FF05.:B5./60,使用换行符进行分隔，一次最多添加20个`,
    required: '必填',
    noCaseIP: 'IP地址有误',
    more20: '最多输入20个IP地址',
    confirmDeleteIP: '确认要删除此IP吗？'
  },
  progress: {
    // 查看进度dialog
    checkprogress: '查看进度',
    total: '提交总数',
    called: '已呼叫次数',
    unreached: '未接通数',
    reached: '已接通数',
    ok: '确定',
    overview: '查看',
    title: '正在上传',
    tip: '正在为您上传名单，可能需要几分钟，请耐心等待'
  },
  tips: {
    // 二次确认提示框
    tips: '提示',
    start: '未到时间确认开始吗？',
    cancel: '是否确定取消？',
    pause: '是否确定暂停？',
    resume: '是否确定恢复？',
    close: '是否确定关闭？',
    close_strategy: '是否确定关闭此界面？注意，关闭后操作将不会被保存！',
    loading: '加载中',
    plsSelect: '请选择',
    plsEnter: '请输入',
    regName: '请输入字母数字或下划线',
    regPhone: '请输入正确的电话号码',
    regUrl: '请输入正确的URL',
    starttip: '立即呼叫',
    back: '返回',
    confirmDel: '确认删除吗？',
    opsSuccess: '操作成功'
  },
  testcall: {
    // testcall
    maxwarn: '当前测试呼叫数已达上限制',
    selecttimewarn: '请选择开始时间和结束时间后再开始查询',
    search: '搜索',
    type: '外呼类型',
    interval: '重拨间隔（分钟）',
    num: '重拨次数（不含首次）',
    testName: '单次呼叫测试名称',
    test: '单次呼叫测试',
    inputAccount: '请输入账户',
    addTest: '指定策略加拨',
    addTask: '指定任务加拨',
    addCall: '添加加拨',
    account: '加拨账户',
    taskName: '任务名称',
    selectTask: '所选加拨任务',
    stime: '开始时间(加拨时区)',
    etime: '结束时间(加拨时区)',
    sta: '开始时间(账户时区)',
    eta: '结束时间(账户时区)',
    subTask: '子任务',
    list: '名单量',
    label: '标签',
    robotName: '机器人名称',
    status: '加拨状态',
    scs: '所选加拨策略',
    callTime: '加拨持续日期',
    callNum: '加拨轮次',
    accountTime: '账户时区',
    addType: '加拨类型',
    adds: '加拨策略',
    addSet: '加拨设置',
    tip: '注：时间均为账户时区时间',
    sd: '开始日期',
    ed: '结束日期',
    sat: '请选择加拨持续日期',
    roundName: '单轮名称',
    robot: '机器人',
    st: '开始时间',
    et: '结束时间',
    opera: '操作',
    addc: '加拨',
    cac: '取消加拨',
    at: '绝对时间',
    rt: '相对结束时间',
    atb: '批量添加任务',
    atbTip: '支持批量添加，任务名称之间需要换行',
    adddetail: '加拨明细',
    addID: '加拨ID',
    cat: '加拨任务',
    pa: '请先选择加拨账户',
    aea: '添加/编辑加拨任务',
    aib: '批量添加',
    pst: '请选择开始时间',
    pet: '请选择结束时间',
    reset: '清空',
    save: '保存',
    ln: '名单量',
    ct: '创建时间',
    cstatus: '呼叫状态',
    remarks: '备注',
    saname: '所选账户的任务名称',
    rtst: '关联任务的外呼开始时间',
    rtet: '关联任务的外呼结束时间'
  },
  taskoverview: {
    taskoverview: '任务总览',
    overview: '总览'
  },
  formrulestips: {
    // RuleForm的提示语
    taskname: '请输入任务名称',
    strategyname: '请输入策略名称',
    planname: '请输入计划名称',
    strategy: '请选择呼叫策略',
    repeat_interval: '请选择重复间隔',
    repeat_number: '请选择重复次数',
    intention: '请选择意图',
    base: '请选择base',
    voicetemplate: '请输入语音模板',
    lineselect: '请输入线路选择',
    starttime: '请输入开始时间',
    date: '请输入日期',
    endtime: '请输入结束时间',
    ifexpired: '请选择是否过期作废',
    ifrecall: '请选择是否重拨',
    recallinterval: '请选择重拨间隔',
    maxnumrecall: '请选择最大重拨数',
    utc: '请选择时区',
    yes: '是',
    no: '否',
    uploadsuccess: '上传成功',
    excelempty: '表格为空,上传失败',
    maxlimiation: '上传呼叫数已达上限制',
    reset: '重置'
  },
  form: {
    upload: '上传数据',
    uploadtip: '上传联系人数据',
    submit: '提交！',
    error: {
      uploadsize: '请不要上传大于1m的文件',
      uploadheader: 'Excel表头有误，请按模板填写数据',
      uploadnum: '仅支持上传一个文件！',
      uploadformat: '仅支持上传 .xlsx, .xls, .csv 文件'
    },
    download: '下载模板文件',
    importfail: '条数据未导入成功',
    allfail: '全部数据导入失败'
  },
  tableoperation: {
    pending: '呼叫等待',
    created: '已创建',
    finished: '呼叫结束',
    canceled: '已取消',
    cancel: '取消',
    paused: '已暂停',
    reached: '接通',
    unreached: '未接通',
    calling: '呼叫中',
    planned: '任务队列中'
  },
  login: {
    login: '登 录',
    // lxl 2021-07-22 修改
    //logout: '登出',
    logout: '退出登录',
    slogan: '释放生产力，由AI澎湃驱动',
    footer: '',
    business_cooperation: '',
    all_right_reserved: '',
    input_userName: '请输入账号',
    input_password: '请输入密码',
    login_forget: '忘记密码',
    concurrency_limit: '您的账号已在其他设备登录，为确保账号安全，如非本人操作，请立即重新登录并修改密码。',
    errorMessage: '您的登录已超时，请重新登录。'
  },
  calldetails: {
    translationLanguage: '选择翻译语言',
    prevRecord: '上一录音',
    nextRecord: '下一录音',
    callId: '呼叫ID',
    dialogueRounds: '对话轮次',
    callDetails: '通话详情',
    translation: '翻译',
    downloadRecord: '下载录音',
    calldetails: '通话明细',
    contact: '联系人',
    callid: '呼叫ID',
    callduration: '通话时长',
    intentionlabel: '意向标签',
    callresult: '呼叫结果',
    download: '下载记录',
    reached: '接通',
    unreached: '未接通',
    undialed: '未拨打',
    choosecreate: '选择创建时间',
    choosecall: '选择呼叫时间',
    callnumber: '电话号码',
    timefrom: '呼叫时间(From)',
    timeto: '呼叫时间(To)',
    calltimerange: '呼叫时间',
    inputnumber: '请输入电话号码',
    ringtype: '响铃分类',
    hangtype: '挂断分类',
    comments: '备注',
    questions: '问题结果清单',
    icresult: '信审结果',
    A: 'A: success',
    B: 'B: failed',
    C: 'C: unfinished',
    D: 'D: others',
    E: 'E: no-answer',
    F: 'F: not connected',
    G: 'G: voicemail',
    Yes: 'Y: Yes,用户确认',
    No: 'N: No,用户否认',
    Others: 'O: Others,用户未回复，或者无意义回复',
    Skip: 'S: Skip,机器人未提问',
    Non: '-: 这个问题不存在',
    resultTipTitle: '信审结果的分类取决于机器人流程设计',
    questionsTipTitle: '对每个问题单元的回复',
    tableTitle: '明细列表',
    prompt_robot_name: '请选择机器人',
    prompt_intention: '请选择意向标签',
    call_time: '呼叫时间',
    create_time: '创建时间',
    robot: '机器人',
    prompt_overall_result: '请选择信审结果',
    userHangup: '用户挂断',
    cancelled: '被取消',
    RobotHangup: '机器人挂断',
    all_intention: '全部意向',
    all_result: '全部结果',
    lettersMeaning: '每个问题列表下右侧字母的含义：',
    lettersMeaningLeft: '每个问题列表下左侧字母的含义：',
    letterA: 'A：被叫用户的答案（无法获取时用“-”表示）',
    letterV: 'V：您上传的核验信息（无法获取时用“-”表示）',
    letterR: 'R：A与V的核验结果（一致为Match，不一致为Not match，无核验结果为“-”）',
    mainFlow: '主流程',
    robotPhoneLabel: '机器人通话标签',
    isArtificial: '是否转人工',
    userPhone: '用户号码',
    callingId: '通话ID',
    callingTime: '总通话时长',
    scenario: '业务场景',
    pdfFailReason: '转人工失败原因',
    robotCallTime: '机器人通话时长',
    callDuration: '人工通话时长',
    dialogueRound: '机器人对话轮次',
    callTag: '人工通话标签',
    moreFilter: '更多筛选项',
    visibleFields: '展示和下载字段',
    hotPhone: '热线号码',
    transfer: '未转人工',
    transferSuccess: '转人工成功',
    transferFail: '转人工失败',
    cantConfirm: '尝试转人工，不确定是否成功',
    view: '查看',
    hitMainProcess: '命中主流程',
    callTaskBeginTime: '呼叫任务开始时间',
    beginCallTime: '开始呼叫时间',
    workflowName: 'Workflow名称',
    advancedSettings: '高级设置',
    canSeeFields: '可见字段管理',
    nerSlots: 'NER slots设置',
    eventLabels: 'Event labels设置',
    listVariable: '名单变量设置',
    showTip: '勾选可控制列表展示，筛选项或下载',
    call_task_name: '呼叫任务',
    call_robot: '机器人',
    wf_task: 'Workflow 任务',
    wf_template: 'Workflow 模板',
    call_plan: '呼叫计划',
    call_strategy: '呼叫策略',
    call_id: '呼叫ID',
    phone_number: '电话号码',
    call_intention: '意向标签',
    ringing_type: '响铃分类',
    hangup_type: '挂断分类',
    transfer_status: '是否转人工',
    platform_name: 'Platform',
    task_call_start_time: '呼叫任务开始时间',
    real_call_start_time: '开始呼叫时间',
    ner_slots: 'NER slots',
    event_labels: 'Event labels',
    talk_duration: '通话时长',
    talk_round: '对话轮次',
    task_id: '任务ID',
    contact_name: '联系人',
    answer_time: '接通时间',
    real_call_end_time: '结束呼叫时间',
    call_times: '呼叫次数',
    call_comments: 'Comments',
    asr_result: 'ASR Result',
    phone_call_log: '重拨记录',
    fieldShow: '字段及展示顺序',
    listField: '列表字段',
    selectField: '启用筛选项',
    slotsTitle: 'Slots描述和下载表头设置',
    slotTip1: '说明：Slots配置在机器人流程中，此处展示了所有机器人的槽位。',
    slotTip2: '1.请根据需要配置描述文案；',
    slotTip3: '2.请根据需要配置某槽位被命中后是否可查看，若可查看则通话命中槽位后将在页面上展示对应的描述文案和槽值，若没有配置描述文案，则展示槽位名和槽值；',
    slotTip4: '3.请根据需要配置某槽位被命中后是否可单独作为Excel表头下载，其他槽位和槽值会统一放在Ner slots表头字段下；',
    slotTip5: '4.若需要满足上述2、3点，请在“可见字段管理”中勾选“Ner slots”。',
    slotDes: '描述文案',
    canSee: '是否可查看',
    canDl: '是否作为表头下载',
    eventTitle: 'Event lables下载表头设置',
    eventTip:
      '说明：Event lables配置在机器人流程中，此处展示了所有机器人的Event lables。请根据需要配置某Event lable被命中后是否单独作为Excel表头下载，其他Event lables会统一放在Event lables表头字段下，同时请在“可见字段管理”中勾选“Event lables”。',
    tableDl: '是否作为表头下载',
    listSet: '名单变量查看和下载表头设置',
    variableTip: '说明：此处展示了近6个月至T-1天所有上传的名单变量。请根据需要配置某名单变量是否可在通话详情中查看或者单独作为Excel表头下载。',
    listTitle: '名单变量查看和下载表头设置',
    listTip: '说明：此处展示了近6个月至T-1天所有上传的名单变量。请根据需要配置某名单变量是否可在通话详情中查看或者单独作为Excel表头下载。',
    listVar: '名单变量',
    callInfoTitle: '呼叫任务信息',
    callInformation: '通话信息',
    listInfo: '名单信息',
    listSource: '名单来源',
    asr_ptp: 'PTP',
    detail_status: '名单状态',
    ringing_duration: '响铃时长'
  },
  singeltest: {
    singeltest: '单次呼叫测试',
    template: '请选择语音模板',
    sipselect: '请选择线路',
    calling: '主叫电话',
    called: '被叫电话',
    tele: '请输入电话',
    canused: '剩余测试数目',
    submit: '提交',
    reset: '重置',
    numonly: '电话号码只能输入数字',
    sip: '线路'
  },
  cost: {
    cost: '花费',
    total: '总花费',
    costtitle: '花费($)'
  },
  historicaltask: {
    histaskrecord: '历史任务记录',
    hiscallrecord: '历史通话记录'
  },
  admin: {
    admin: '管理页面',
    company: '公司名称',
    companySelect: '请选择公司名称',
    type: '查询种类',
    timeRange: '查询范围',
    client: '客户名称',
    usedate: '使用日期',
    callnum: '拨打电话个数',
    reached: '接通电话个数',
    unreached: '未接通个数',
    cost: '单价',
    totalcost: '总价'
  },
  error: {
    404: '请检查您输入的网址是否正确，或点击以下按钮返回主页',
    back: '返回首页',
    planadd: '您的计划执行时间已超过原始策略时间，请调整策略后重试！'
  },
  strategy: {
    newround: '添加轮次',
    list: '呼叫策略列表',
    new: '添加策略',
    published: '已发布',
    unpublished: '未发布',
    view: '查看',
    edit: '编辑',
    copy: '复制',
    delete: '删除',
    strategy: '策略名称',
    roundname: '单轮名称',
    roundnumber: '轮数',
    strategyname: '策略名称',
    entername: '输入策略名称',
    maxrecall: '最大重拨数',
    selecttag: '选择标签',
    selectrange: '选择范围',
    tip: '提示：两轮需要间隔15分钟以上！',
    icplandowndtip: '请选择信审呼叫策略！',
    stratrgy_table: '策略列表',
    prompt_strategy_name: '请输入策略名称',
    interval_time: '{round}与前一轮间隔需大于15分钟',
    view_strategy: '查看策略',
    amxTag: '此轮次最多支持12个标签，请重新选择',
    no_robot: '机器人不存在，请重试'
  },
  robotExplain: {
    name: '话术名称',
    language: '话术',
    voice: '机器人语气',
    range: '适用范围',
    paytime: '要求还款时间',
    recorder_gender: '音色性别',
    voice_language: '语言',
    formal: '正式',
    casual: '简短',
    polite: '礼貌',
    natural: '自然',
    tough: '强硬',
    tougher: '施压',
    t4: 'T-4及以上，IVR',
    t3: 'T-3到T0',
    t0: 'T0当天',
    tadd1: '逾期后',
    beforedue: '逾期前',
    today: '今天'
  },
  excel: {
    appexist: '请确认平台名称是否正确',
    dateformat: '日期格式错误，请参考模板样例',
    dateinterval: '贷款日期应当早于还款到期日'
  },
  blacklist: {
    add: '新增黑名单',
    tip1: '支持批量上传',
    tip2: '号码间需要换行',
    invalidTip: '手机号码格式错误',
    successTip: '添加成功',
    deleteTip: '是否确认删除',
    deleteSuccess: '删除成功',
    simpleTip: '黑名单示例',
    limit_service: '限制拨打业务',
    system_names: '系统黑名单',
    manual_names: '人工黑名单',
    bl_type: '黑名单类型',
    bl_list: '黑名单列表'
  },
  assistant: {
    title: '智能屏蔽',
    add: '添加智能屏蔽策略',
    type: '类型',
    days: '策略判定天数',
    result: '通话结果',
    times: '累计次数',
    callTimes: '累计拨打次数',
    shieldDays: '屏蔽天数',
    shieldType: '屏蔽方式',
    lastTime: '最后更新时间',
    tel: '屏蔽号码',
    shieldTime: '屏蔽时间',
    task: '所属任务',
    shieldData: '查看屏蔽数据',
    pblj: '屏蔽逻辑：在创建任务或呼叫时，判断过去 N 天内所拨电话是否满足屏蔽触发条件， 若满足，则按所选屏蔽方式对其屏蔽 M 天，若不满足，则不屏蔽。',
    addznpbcl: '添加智能屏蔽策略',
    clsm: '策略说明',
    leftDay: '过去 N天（策略判定天数 )',
    rightDay: '未来 M天（屏蔽天数 )',
    shaft: '时间轴',
    createCalling: '创建任务/呼叫时',
    timePoint: '时间点 X',
    radioOne: '按通话结果累计次数屏蔽',
    radioTwo: '按累计拨打次数屏蔽',
    inputOne: '屏蔽类型',
    inputTwo: '策略判定天数 ',
    inputThree: '屏蔽触发条件',
    checkboxOne: '创建任务时屏蔽',
    checkboxTwo: '呼叫时屏蔽',
    spanOne: '累计拨打次数',
    spanTwo: '通话结果标签',
    spanThree: '累计次数',
    tooltip1: '此类型会根据您填写的判定天数内同一电话共出现选中标签xx次来进行屏蔽，若选中的标签为多个，则累计次数为这多个标签加起来的累计次数。',
    tooltip2: '此类型会根据您填写的判定天数内同一电话被呼叫xx次来进行屏蔽。',
    tooltip3: '号码被屏蔽前策略需要监控的天数（含当天）',
    tooltip4: '指策略将会屏蔽命中号码的天数（含屏蔽开始当天）；如某号码今天开始屏蔽2天，则会屏蔽今天和明天，明天23:59:59后取消屏蔽。',
    tooltip5: '创建任务时，命中的电话号码将被屏蔽，无法上传',
    tooltip6: '呼叫时，命中的电话号码将被屏蔽，无法拨打',
    placeholder: '请输入1～180',
    tian: '天',
    ci: '次',
    shieldTimes: '屏蔽次数',
    smartNumber: '智能屏蔽数',
    rule6: '请输入1-180的正整数',
    rule7: '请输入正整数',
    rule1: '请选择屏蔽类型',
    rule2: '请输入策略判定天数',
    rule3: '请输入屏蔽触发条件',
    rule4: '请输入屏蔽天数',
    rule5: '请选择屏蔽方式'
  },
  collectionTags: {},
  marketingTags: {},
  infoCheckTags: {},
  personalInfo: {
    current_password: '当前密码',
    input_current_password: '请输入当前密码',
    input_new_password: '请输入新密码',
    error_current_password: '密码不正确',
    title: '个人信息',
    group: '分组',
    role: '角色',
    account: '账号',
    icon: '头像',
    resetIcon: '修改头像',
    accountInfo: '账号信息',
    basicInfo: '基础信息',
    new_password: '新密码',
    error_confirm_password: '2次密码不一致'
  },
  message: {
    lessCurrentTime: '开始时间不能小于当前时间',
    lessFiveMin: '结束时间和开始时间的间隔不能小于5分钟',
    errorStrategyTime: '所选策略时间早于当前时间，计划无法创建成功',
    fail: '导入名单全部失败',
    upload: '请上传名单！'
  },
  robot: {
    detail: '查看详情',
    valid: '有效',
    invalid: '无效',
    state: '状态',
    action: '操作',
    robot_name: '机器人名称',
    create_time: '创建时间',
    update_time: '更新时间',
    audition: '试听',
    now_words: '当前话术',
    words_list: '话术列表',
    history: '操作历史',
    create_words: '新建话术',
    update_words: '编辑话术',
    words_update: '话术编辑',
    words_preview: '话术预览',
    words: '话术',
    apply: '应用',
    update: '编辑',
    delete: '删除',
    fill_words: '请填写试听变量',
    start_audition: '开始试听',
    confirm_delete: '确认删除该话术吗？',
    confirm_apply: '确认应用该话术吗？',
    sensitive_word: '为敏感词，请替换后重试。',
    suggest_cut: '话术超过90s，建议缩减。',
    add_words: '新增话术',
    apply_words: '应用话术',
    delete_words: '删除话术',
    explain: '说明：请复制想用的参数至文本框中进行话术编辑',
    all_params: '所有参数',
    params_explain: '参数说明',
    submit: '提交',
    serial_number: '序号',
    operation_type: '操作类型',
    operation_time: '操作时间',
    operator: '操作人',
    can_not_empty: '话术不能为空',
    integrity: '请将试听变量填写完整',
    greetings: '问候语，实际拨打中会根据拨打时间自动生成 ',
    borrower_name: '用户姓名，营销业务中此参数对应模板中的customer_name ',
    gender: '用户性别',
    borrow_money: '借款金额，此参数对应模板中的borrowed_amount ',
    borrow_total_money: '总借款金额，此参数对应模板中的total_owing_amount ',
    borrow_date: '借款日期，此参数对应模板中的borrowed_date ',
    due_date: '借款到期日期 ',
    due_days: '借款逾期天数，此参数是根据due_date自动转换的，在上传名单时无此参数 ',
    due_month: '逾期月，此参数是根据due_date自动转换的，在上传名单时无此参数 ',
    platform: '平台名称，此参数对应模板中的platform_name',
    borrow_month: '借款月，此参数是根据borrow_date 自动转换的，在上传名单时无此参数 ',
    extra_a: '拓展字段',
    extra_b: '拓展字段',
    extra_c: '拓展字段',
    extra_d: '拓展字段',
    enter: '请输入',
    active: '生效中',
    ineffective: '未生效',
    edit_remark: '编辑备注',
    remark: '备注',
    remark_max_length: '备注最长为40个字符',
    robotId: '机器人ID',
    idDesc: '此ID主要用于API对接时选择相应机器人',
    tone: '语气',
    robotGender: '性别',
    auditionRecord: '试听录音',
    politeness: '礼貌',
    nature: '自然',
    tough: '强硬',
    pressure: '施压',
    cruel: '凶狠',
    detailTab1: '标签说明',
    detailTab2: '机器人变量',
    detailTable1: '标签',
    detailTable2: '说明',
    detailTable3: '变量',
    detailTable4: '规则',
    detailTable5: '示例',
    labelGroup: '事件标签分组',
    groupTip: '说明：可对同一机器人下的事件标签进行分组设置，设置后将新增展示分组名称，未分组则只展示原有事件标签',
    groupbtn1: '组合',
    groupbtn2: '取消组合',
    groupbtn3: '组合名称',
    errTip: '请选择multi_intention',
    groupTableTitle: '事件标签组',
    dashboardTip1: '标签权重为{name}，将按此权重进行去重',
    dashboardTip2: 'All the numbers指所有名单，标签权重为{name}，若同一电话号码在之前的round中打出多个不同的标签，系统将优先按照权重较高的标签选择名单',
    dashboardTip3: '此处展示的均为web端模板变量，API变量请以API文档为准。'
  },
  safetyLogin: {
    change_email: '换绑邮箱',
    desc_new_email: '请输入新的邮箱进行验证',
    binding_email: '绑定邮箱',
    desc_email: '请输入邮箱进行验证',
    to_bind: '去绑定',
    prompt_email: '请输入邮箱',
    invalid_email: '无效的邮箱',
    enter_code: '请输入验证码',
    fetch_code: '获取验证码',
    area_code: '电话区号',
    prompt_mobile: '请输入手机号码',
    bind_mobile: '绑定手机号',
    invalid_mobile: '无效的手机号',
    error_code: '验证码错误，请重试',
    prompt_area_code: '请选择国际电话区号',
    again: '{number}s后重新获取',
    safety_verification: '安全验证',
    verify_desc: '为了确认是您本人操作，请先进行邮箱验证'
  },
  crossLogin: {
    name: '穿越登录',
    list: '账号列表',
    companyName: '企业名称',
    placeholder: '请输入登录账号或企业名称',
    tip: '当前为穿越登录，不支持此操作',
    checkout: '退出登录'
  },
  LoginInfo: {
    login_set: '登录设置',
    enabled: '启用中',
    not_enabled: '未启用',
    declare: '说明：为了您的账号安全，建议您开启2FA；开启后您需要绑定本人邮箱，以备安全验证时收取动态验证码',
    login_log: '登录记录',
    desc: '以下是您最近1个月的登录记录，若存在异常登录记录，请尽快修改密码',
    open_FA: '开启2FA',
    serial: '序号',
    equipment: '设备系统',
    browser: '浏览器',
    area: '地区',
    login_time: '登录时间'
  },
  template: {
    callTime: '拨打时间',
    experience_robot: '体验机器人',
    select_industry: '选择行业',
    desc_first: '请根据您的需求，选择合适的机器人进行呼叫体验',
    desc_second: '您填写的内容将自动填充至呼叫机器人的话术中',
    ps_industry_scenario: '请选择行业-场景',
    ps_kansalliskieli: '请选择国家-语言',
    industry: '行业',
    ps_industry: '请选择行业',
    scenario: '场景',
    ps_scenario: '请选择场景',
    dial_country: '拨打国家',
    ps_dial_country: '请选择拨打国家',
    robot_language: '机器人语言',
    ps_robot_language: '请选择机器人语言',
    time_zone: '时区',
    select_time: '选择时间',
    dial: '拨打电话',
    pe_dial: '请输入拨打电话',
    country_code: '国家代码',
    pe_borrower_name: '请输入借款人姓名',
    pe_borrowing_balance: '请输入借款金额',
    total_amount_borrowed: '总借款金额',
    pe_total_amount_borrowed: '请输入总借款金额',
    ps_Later_current_time: '请选择晚于当前时间的时间点',
    length_limit: '长度在 8 到 20 个字符',
    ps_start_time: '请选择开始时间',
    ps_borrowing_date: '请选择借款日期',
    ps_due_date: '请选择借款到期日期',
    country: '国家',
    language: '语言',
    recording_audition: '录音试听',
    experience_immediately: '立即体验',
    selectIndustry: '选择行业和场景',
    industryList: '行业目录',
    robot: '机器人',
    timbre: '音色',
    tone: '语气',
    rangeApplication: '适用范围',
    allIndustry: '全部行业'
  },
  tools: {
    manual: '操作手册',
    document: 'API文档',
    product: '业务',
    tip1: '请选择业务',
    tip2: '请选择语言',
    download_doc: '下载文件',
    all: '全部标记已读',
    infoList: '消息列表',
    more: '查看更多',
    viewNow: '立即查看',
    newVersion: '最近更新',
    hisVersion: '历史版本',
    appTip: '',
    auth: '申请授权',
    cancelAuth: '取消授权',
    isCancel: '是否取消授权?'
  },
  action: {
    listTime: '操作时间',
    list: '操作列表',
    listAccount: '操作账号',
    listModule: '操作模块',
    listContent: '操作内容',
    taskAdd: '添加任务{name}',
    taskOpen: '开始任务{name}',
    taskCancel: '取消任务{name}',
    taskStop: '暂停任务{name}',
    taskRecover: '恢复任务{name}',
    taskDownloadList: '下载任务列表',
    taskDownloadName: '下载任务名单{name}',
    taskDownloadDetail: '下载任务明细{name}',
    planAdd: '添加计划{name}',
    planCancel: '取消计划{name}',
    planDownloadList: '下载计划列表',
    planDownloadName: '下载计划名单{name}',
    strategyAdd: '添加策略{name}',
    strategyEdit: '编辑策略{name}',
    strategyDelete: '删除策略{name}',
    callDetail: '下载通话明细',
    blackListAdd: '增加黑名单',
    blackListDelete: '删除黑名单',
    blackListDownload: '下载黑名单',
    shieldAdd: '增加智能屏蔽策略{name}',
    shieldEdit: '编辑智能屏蔽策略{name}',
    shieldDelete: '删除智能屏蔽策略{name}',
    shieldStop: '停用智能屏蔽策略{name}',
    shieldOpen: '启用智能屏蔽策略{name}',
    robotDownload: '下载机器人',
    robotEdit: '编辑{name}备注',
    robotAdd: '新增{name}话术',
    robotEditWord: '编辑{name}话术',
    robotApply: '应用{name}话术',
    robotDelete: '删除{name}话术',
    createTask: '创建任务{name}',
    createPlan: '创建计划{name}',
    callDelete: '取消拨打电话{name}',
    crossLogin: '穿越登录{name}',
    tip: '以下是您所在企业所有账号的操作记录，支持查询最近半年的记录',
    templateSave: '保存',
    templateDel: '删除',
    workflowAdd: '新增',
    workflowAddList: '新增名单',
    workflowCancel: '取消',
    versionSave: '保存',
    versionPublish: '发布',
    versionActive: '启用',
    versionArchive: '归档',
    versionSaveDes: '保存描述'
  },
  downloadCenter: {
    downloadCenter: '下载中心',
    progress: '正在准备数据',
    create: '待处理，预计5分钟内开始处理',
    rehandling: '点击后重新处理',
    status5: '正在写入文件'
  },
  workFlow: {
    list: 'Workflow 列表',
    add: '添加 Workflow模板',
    workflowName: 'Workflow 模板名称',
    placeholder: '请输入Workflow名称',
    name: '名称',
    dec: '描述',
    modifyUser: '更新人',
    listNum: '名单数',
    checkTask: '查看子任务',
    addList: '新增名单',
    setTask: '设置 Workflow 任务',
    inputName: '请输入名称',
    inputDes: '请输入描述',
    timeType: '触发方式',
    timeType1: '指定时间触发',
    timeType2: '多长时间后触发',
    timeTip1: '指定在第几天、几点触发',
    timeTip2: '关联 Action 完成多久后触发',
    timeTitle: '触发时间',
    timeTip3: '请选择日期',
    timeTip4: '请选择时刻',

    // TimeV2 Drawer
    timeV2Type: '放行方式',
    timeV2Type1: '指定时间放行',
    timeV2Type2: '等待一定时间后放行',
    timeV2Tip1: '名单将停留在当前节点，满足日期和时刻条件时，将放行名单进入后续节点',
    timeV2Tip2: '名单将停留在当前节点，满足等待时间后放行名单，进入后续节点',
    timeV2AbsoluteDateTitle: '日期',
    timeV2AbsoluteDateType1: '在名单进入当前节点',
    timeV2AbsoluteDateType2: '在名单上传到workflow',
    timeV2AbsoluteTimeTitle: '时刻',
    timeV2AbsoluteTimeCurrent: '当前时间',
    timeV2RelativeTimeTitle: '等待时间',
    timeV2RelativeTimeHour: '小时',
    timeV2RelativeTimeMinute: '分钟',
    dateTime: '自定义时间',

    manualTitle1: 'Web提醒设置',
    manualTitle2: '消息发送时间',
    manualTip: '最近的 Action完成多久后，在Calling消息中心提醒',
    uslTitle1: '条件',
    uslTitle2: '标签类型',
    uslTitle3: '机器人',
    uslTitle4: '大标签',
    uslTitle5: '事件标签',
    uslTitle6: '新增一个“or”条件',
    uslTitle7: '新增事件标签',
    splitterTitle1: '组',
    splitterTitle2: '新增一个分组',
    splitterTitle3: '实验组的流量占比综合必须等于100%',
    caTitle1: '判断',
    caTitle2: '属性名称',
    caTitle3: '数据类型',
    caTitle4: '关系',
    caTitle5: '新增一个“and”判断',
    caTitle6: '数字',
    caTitle7: '字符',
    caTitle8: '日期',
    caTitle9: '时间',
    apiTip1: '',

    // OBCall Drawer
    ocTitle1: '重拨间隔',
    ocTitle2: '重拨次数',
    ocTitle3: '名单管理策略',
    ocTitle4: '批次最大名单数',
    ocTitle5: '批次等待时间',
    ocTip1: '按批次维度，管理名单的外呼和放行',
    ocTip2: '名单数超过该设置时，会立即创建一个批次，并开始外呼',
    ocTip3: '名单进入该节点的时间等待该设置，会立即创建一个批次，并开始外呼',

    smsTitle1: '内容',
    smsTitle2: '发送渠道',
    smsTitle3: '短信字符数',
    smsTitle4: '更换模版',
    smsTitle5: '选择短信模版',
    smsTitle6: '短信模版列表',
    smsTitle7: '选择WhatsApp模板',
    smsTitle8: 'WhatsApp模板列表',
    smsTitle9: '确认',
    smsTable1: '模版名称',
    smsTable2: '内容',
    smsTable3: '短信渠道',
    smsTable4: '字符数',
    pending: '进行中',
    taskType: '任务类型',
    checkLabel: '请选择大标签或事件标签',
    include: '包含',
    exclude: '不包含',
    startswith: '以...开始',
    endwith: '以...结束',
    cancelTip: '取消后任务无法恢复，确认取消吗？',
    uliTip: '大标签与事件标签至少填一个',
    childPending: '等待中',
    searchTip: '全部Workflow',
    childName: '子任务名称',
    callName: '呼叫任务名称',
    clickRateTip2: '此处计算的点击率分母是发送量，不是发送成功量，仅供参考',

    // PDS Drawer
    pdsTitle1: '人工座席组',
    pdsTitle2: '座席呼叫间隔',
    pdsTitle3: '槽位系数类型',
    pdsTitle4: '自动',
    pdsTitle5: '手动',
    pdsTitle6: '响铃最大时长',
    pdsTitle7: '任务最小名单数',
    pdsTitle8: '任务等待时长',
    pdsTitle9: '语音信箱检测',
    pdsTitle10: '语音信箱检测时长',
    pdsTip1: '响铃时间超过该时长仍未接通，会由系统主动挂机（最大时长180秒）',
    pdsTip2: '进入该节点的名单数累计超过最小名单数时，会立即生成PDS外呼任务',
    pdsTip3: '当首尾名单进入该节点超过该时长，会立即生成PDS外呼任务',
    pdsTip4: '任务结束后，将自动进行QA检测',
    pdsTip5: '检测通话是否为语音信箱，只有非语音信箱的通话才会进线给座席',
    pdsTip6: '检测语音信箱的最大时间，超过该时间后视为非语音信箱',
    pdsTip7: '针对未接通电话的重拨间隔',
    pdsTip8: '针对未接通电话的最大重拨次数',

    urlClickTitle: '短链有效时间',
    apiTip: '',
    humanAgentTitle: '对话结果',
    overview: '数据概览',
    dataTip1: '等待处理中的名单数',
    dataTip2: '执行中',
    dataTip3: '已完成',
    dataTip4: '接通数',
    dataTip5: '接通率',
    dataTip6: '发送量',
    dataTip7: '点击数（7天内）',
    dataTip8: '点击率（7天内）',
    labelTitle: '标签分布',
    immediately: '立即触发',
    obcallTitle: '上游OB Call节点',
    allDataView: '数据总览',
    coTitle1: '选择节点',
    coTitle2: '节点',
    coTitle3: '设置大标签优先级',
    coTitle4: '设置分流条件',
    coTitle5: '分流条件',
    coTitle6: '新增分流条件',
    coTitle7: '新增节点',
    coTip1: '请选择需要判断大标签优先级的节点',
    coTip2: '请按照“ 大标签 ”与 “>”的格式修改优先级，例如:“A>B>C>D>E>F>G>H”',
    coTip3: '各分流条件将在节点连线时展示，分流条件不能重复',
    chartTitle1: '最终标签分布',
    chartTitle2: '名单流转action数',
    chartTitle3: '名单流转情况',
    chartSelect2: '全部渠道',
    chartSelect3: '全部最终标签',
    checkTitle1: '已运行',
    checkTitle2: '天',
    checkTitle3: '小时',
    checkTitle4: '分钟',
    checkTitle5: '名单上传时间段',
    actionViewTitle: '配置信息',
    dataTip9: '已处理名单数',
    isClick: '7天内是否点击',
    clickTime: '点击时间',
    existName: '节点名称已存在，请修改后再试',
    viewTip1: '指筛选时间段内已上传至workflow任务的总名单数',
    viewTip2: '指筛选时间段内的名单平均流转的outbound call action数',
    viewTip3: '指筛选时间段内的名单平均流转的action数（其中不含API action）',
    viewTip4: '指筛选时间段内的名单的总outbound call拨打次数（不含action内的重拨次数）',
    viewTip5: '指筛选时间段内的名单的总outbound call接通数',
    viewTip6: '指筛选时间段内的名单的总outbound call接通率',
    viewTip7: '指筛选时间段内的名单，总SMS发送数量',
    viewTip8: '指筛选时间段内的名单在发送SMS的7天内的短链点击量（多次点击仅算一次）',
    viewTip9: '指筛选时间段内的名单在发送7天内的短链点击率',
    viewTip10: '指筛选时间段内的名单，总WhatsApp发送数量',
    viewTip11: '指筛选时间段内的名单在发送WhatsApp的7天内的短链点击量（多次点击仅算一次）',
    viewTip12: '指筛选时间段内的名单在发送7天内的短链点击率',
    viewTip13: '指筛选时间段内的名单的总PDS拨打次数',
    viewTip14: '指筛选时间段内的名单的总PDS接通数',
    viewTip15: '指筛选时间段内的名单的总PDS接通率',
    viewTitle1: '指筛选时间段内的名单的最终标签分布情况',
    viewTitle2: '指筛选时间段内的名单，其产生最终标签所经历的action数量（不含API action）',
    viewTitle3: '指筛选时间段内的名单在action间的流转情况',
    urlClickTitle1: 'SMS/WA节点',
    caTitle10: '子条件',
    slotTip: '触发时间由所选槽位决定，到时名单将进入后续流程',
    slotTitle1: 'OB Call节点',
    slotTitle2: '槽位',
    slotTitle3: '触发方式',
    slotSelect1: '准点触发',
    slotSelect2: '提前触发',
    slotSelect3: '延后触发',
    nowDay: '当天',
    howDay: '第{name}天',
    delTip: '删除此节点将影响已引用此节点的{name}等节点的数据，导致workflow异常，请删除后立即修改受影响的节点数据',
    saveTip: '检测到 {name} 信息未保存，请保存后重试',
    everyDay: '每天',
    ocsTitle1: '单轮名称',
    ocsTitle2: '跟进轮次与标签',
    ocsTitle3: '大标签/事件标签',
    ocsTitle4: '轮次',
    ocsTitle5: '添加轮次',
    ocsSort: '轮次按时间排序',
    ocsError1: '时间最早跟进轮次必须选择Initial',
    ocsError2: '{name}的拨打时间周期应大于重拨间隔*重拨次数',
    ocsError3: '{name}的开始时间应晚于{target}的结束时间',
    ocsError4: '{name}、{target}跟进轮次和标签有重复',
    ocsError5: '单轮名称有重复',
    ocsError6: '仅一个跟进轮次能选择Initial',
    ocsError7: '跟进轮次仅能选择一个All',
    obcallTitle2: '上游PDS节点',
    close: '关闭',
    errorTip1: '没有指向该节点的其他节点',
    errorTip2: '触发时刻设置过早/过晚',
    errorTip3: '触发天数设置过晚',
    errorTip4: '未设置分流条件=others的出口',
    btn1: '自检',
    btn2: '发布',
    btn3: '设置',
    autoSave: '自动保存中',
    autoSave1: '自动保存',
    autoSave2: '自动保存周期',
    min: '分钟',
    on: '开启中',
    off: '关闭中',
    errTipTitle: '发现了{name}个错误',
    errTipTip: 'Tips：点击节点名称可自动定位问题节点',
    againCheck: '再次自检',
    saveSuccess: '保存草稿成功',
    checkSuccess: '自检成功',
    apiTitle2: '上游节点',
    apiTitle3: '自定义数据',
    apiTitle4: '字段名',
    apiTitle5: '值',
    apiTitle6: '增加字段',
    apiTip3: '',
    apiTip4: 'API 文档了解详情',
    apiTip5: '字段名重复',

    endtimeTip: 'workflow任务只会在指定时间结束，即便已执行完当前所有名单',
    autoFinishTip: '当最后一个节点执行完所有名单后，workflow任务会自动结束',
    pdsReason: '转人工原因',
    pdsReasonTip: '会在座席来电提醒界面展示转接原因',
    batchModify: '批量修改',
    components: '组件',
    addComponents: '新建组件',
    editComponents: '编辑组件',
    saveNew: '保存成新组件',
    associationTemplate: '与模板配置一致',
    processConfig: '查看组件',
    inputVersionDes: '请输入版本描述',
    tempDesc: '模版描述',
    viewComponentExecutionDetails: '查看组件执行详情',
    delComponent: '删除该组件',
    delComponentTip: '是否删除该组件?',
    nohaveinputoroutput: '缺少Input或Output节点',
    noComponent: '暂无组件，请先新建一个组件',
    autoFinish: '自动结束',
    delTips: '确认删除 [{name}]?',
    tips: '提示',
    pdsTitle11: '联系方式呼叫间隔',
    pdsTip9: '同一名单不同联系方式间的呼叫间隔',
    dnc: 'DNC策略',
    year: '年份',
    holidayType1: '当日期属于以下任一分类时放行',
    holidayType2: '当日期不属于以下所有分类时放行',
    holidayTask1: '在节假日暂停',
    holidayTask2: '暂停日期',
    holidayTip: '“在节假日暂停”指workflow任务开始运行时或账户时区每日05:00判断当日是否在选定的暂停日期分类下，若是，则该workflow任务会在当日自动暂停一日，直至第二日05:00再次判断',
    mail1: '收件人',
    mail2: '发件人',
    mail3: 'Email模板列表',
    mail4: '选择Email模板列表',

    // timev2
    noVariable: '日期时刻非变量',
    allVariable: '日期时刻均为变量',
    fixVariable: '日期固定时刻变量',
    fixVariable2: '日期变量时刻固定',

    // waba template
    wabaAccount: 'WABA账号',
    templateName: '模板名称',
    templateContent: '模板内容',
    contentView: '内容预览',
    selectWABATemplate: '选择WABA模板',
    wabaAccountAnd: 'WABA账号及模板列表',
    preview: '预览',
    relateChatbot: '关联Chatbot',
    selectChatbot: '选择Chatbot',
    robotVersion: '机器人版本',
    noRelateCb: '不关联Chatbot',
    preOnline: '待上线',
    online: '已上线',
    noRelate: '未关联',
    selectRobot: '所选机器人无待上线或已上线版本',
    selectVersion: '版本状态不是待上线或已上线',

    // data overview
    wfTemplate: 'Workflow模板及版本',
    callListTrend: '拨打名单数趋势',
    allLabel: '全部标签',
    labelDistriTrend: '标签分布趋势',
    callDurationDistri: '通话时长分布',
    callDurationTrend: '通话时长分布趋势',
    ringDistribution: '响铃分类',
    uploadListTrend: '上传名单数趋势',
    hangUpDistribution: '挂断分类',
    transferTrend: '转人工率趋势',
    successNum: '成功转人工数',
    dupListNum: '去重名单数',
    cancelListNum: '取消名单数',
    updateListNum: '更新名单数',
    createWFTaskNum: '创建workflow任务数',
    runningWFTaskNum: '执行中workflow任务数',
    theSameNum: '，同一电话号码的不同标签去重后取优先级最高的结果',
    redialListNumber: '去重拨打名单数',
    deconnecting: '去重接通名单数',
    disconnection: '去重接通率',
    callNumbers: '总拨打轮次数',
    rounds: '总接通轮次数',
    connectionRate: '总接通率',
    connectedCalls: '接通电话平均拨打轮次数',
    averageNumber: '平均拨打次数',
    numberConnectedCalls: '接通电话平均拨打次数',
    averageCallDuration: '平均通话时长(s)',
    interactive: '平均交互轮次',
    ringingDuration: '平均响铃时长(s)',
    turnLaborNumber: '尝试转人工数',
    transferLaborRate: '尝试转人工率',
    successfulTransfers: '成功转人工数',
    successRate: '转人工成功率',
    shortMessage: '发送总名单数',
    singularName: '发送去重名单数',
    waShortMessage: 'WhatsApp发送总名单数',
    waSingularName: 'WhatsApp发送去重名单数',
    day7Hits: '去重7日点击数',
    clickThroughRate: '去重点击率',
    transmissions: '总发送数',
    day7HitsTotal: '总7日点击数',
    clickRate: '点击率',
    averageTransmissions: '平均发送次数',
    messageSendingLists: '发送名单数趋势',
    clickRateTrend: '点击率趋势',
    sendNum: '发送数',
    click7: '7日点击数',
    pdsListNum: 'PDS名单数',
    pdsDepListNum: 'PDS去重名单数',
    pdsTitle: 'PDS名单数趋势',
    waSend: 'WA Template发送总名单数',
    waDupSend: 'WA Template发送去重名单数',
    allSend: '总发送数',
    averageSend: '平均发送次数',
    waSend2: 'WA Template发送名单数趋势',
    waSendNumTrend: '发送数趋势',
    includeUpload: '包括已上传和已新增的所有名单',
    defaultCallNum: '默认按照电话号码去重，不同workflow内有重复电话号码的情况也会统一去重',
    cancelSuccess: '取消成功的名单数',
    updateMessage: '更新信息成功的名单数',
    createSuccess: '创建成功的workflow任务数',
    producingTasks: '正在执行中的workflow任务数',
    everyDay: '每日已上传和已新增的所有名单的变化情况，去重规则是默认按照电话号码去重',
    onlyT1: '仅支持下载T-1离线数据',
    allList: '总被拨打名单数',
    atCallNum: '按照电话号码去重后的总被拨打名单数',
    receivedAtLeast: '接通过至少一次的电话数',
    dereferenceRate: '电话号码维度的去重接通率，是去重接通名单数➗去重拨打名单数*100%',
    missedRedials: '总拨打轮次数（不包括轮次内未接通的重拨次数）',
    numberRounds: '总接通轮次数',
    numberCalls: '总接通轮次数➗总拨打轮次数*100%',
    averageRounds: '已接通的电话号码的平均拨打轮次数（不包括轮次内未接通的重拨次数），此字段不受机器人和platform筛选项影响',
    averageCallNum: '每个号码的平均拨打次数（包括轮次内未接通的重拨次数），此字段不受机器人和platform筛选项影响',
    connectedNum: '已接通号码的平均拨打次数（包括轮次内未接通的重拨次数），此字段不受机器人和platform筛选项影响',
    averageDuration: '已接通电话的平均通话时长',
    averageActive: '已接通电话的平均有效交互轮次',
    averageRing: '已拨打电话的平均响铃时长（不包括轮次内未接通的重拨记录）',
    numberAttempts: '已拨打电话的尝试转人工数',
    attemptedTransfer: '已接通电话的尝试转人工率，为尝试转人工数➗总接通轮次数*100%',
    successfulCallsTransferred: '已拨打电话的成功转人工数',
    proportionCalls: '尝试转人工的电话中成功转人工的电话占比',
    dialedListChanges: '每日已拨打名单的变化情况，去重规则是默认按照电话号码去重',
    theDeduplicationRule: '全部通话标签的分布情况，去重规则是按照标签优先级去重',
    dailyCall: '每日通话标签的分布情况，去重规则是按照标签优先级去重',
    basedPhone: '每日已拨打电话的接通率变化情况，去重规则是默认按照电话号码去重',
    allConnectedCalls: '全部已接通电话的通话时长分布情况',
    durationDistribution: '每日已接通电话的通话时长分布情况',
    ringTypes: '全部已拨打电话中响铃类型分布情况',
    hangUpTypes: '全部已拨打电话中挂断类型的分布情况',
    transferTate: '每日已接通电话的转人工率变化情况',
    sentMessages: '总被发送信息名单数',
    messagesSent: '按照电话号码去重后的总被发送信息名单数',
    afterSending: '按照号码去重后的点击数，仅统计发送后7日内短链是否被点击',
    rateSfter: '按照号码去重后的点击率',
    shortChain: '仅统计发送后7日内短链是否被点击，点击多次仅统计最早的一次记录',
    averageNumberMessage: '信息的平均发送次数',
    listSentmessages: '每日已发送信息的名单的变化情况，去重规则是默认按照号码去重',
    clickRateSent: '每日已发送信息的点击率变化情况，数据T+1天更新，去重规则是默认按照号码去重',
    nodesToEnter: '进入PDS节点的名单数量（更多数据请至AICC平台查看）',
    deduplicationLists: '进入PDS节点的去重名单数量，按照电话号码去重',
    listOfPDS: '每日进入PDS节点的名单的变化情况',
    WATemplateMessages: '每日已发送WA Template信息的名单的变化情况',
    timesThatWA: '每日发送WA Template信息次数的变化情况，去重规则是默认按照号码去重',
    workflowTem: 'Workflow模板',
    wfDrawerTip: '可以选择的最晚日期是距离当前时间两个月之后。',
    realtime: '实时',
    offline: '离线',
    sendNumTip: '请求发送的信息数量，不代表发送成功和送达成功。',
    aveTip: '去重电话的平均请求发送次数',
    sendedNum: '送达数',
    sendedNumTip: '运营商成功发送的信息数量，超过字符数将1条信息拆分为2条进行发送的情况会计为2条',
    sendSuc: '发送成功数',
    sendedNumTip2: '运营商在接收到请求后成功执行发送的次数',
    uniqSendSuc: '去重发送成功数',
    uniqSendedNumTip: '按照电话号码去重后的运营商在接收到请求后成功执行发送的次数',
    clickRateTip: '发送7日内短链被点击的次数占发送成功数的占比（多次点击仅统计1次）',
    uniqClickRateTip: '发送7日内短链被点击的次数占去重发送成功数的占比（多次点击仅统计1次）',

    // calendar
    delSelect: '删除选中',
    batchAddHoliday: '批量添加自定义节日',
    uploadCustom: '导入自定义节日',
    check: '校验',
    title2: '上传填写好的文件',
    fileTypeError: '文件格式错误，请重试',
    max2M: '请上传＜2M的文件',
    pleaseUpload: '请先上传文件',
    dlError: '下载查看失败原因',
    allData: '总数据',
    calendarUpload: '节日已上传',
    calendar5s: '5s后自动收起该页面',
    delTip2: 'workflow template中可能引用自定义节日，请谨慎删除。'
  },
  ca: {
    action: 'Action参数',
    list: '名单参数',
    system: '系统参数',
    diy: '自定义参数',
    common: '通用参数',
    fun: '运算参数',
    funTip: '函数说明',
    bj1: '介于...之间',
    bj2: '为空',
    bj3: '不为空',
    bj4: '是否节假日',
    max: '最大值',
    min: '最小值'
  },
  desc: {
    date_sub_desc: '日期参数相减，得到天数的差值'
  },
  dataView: {
    title1: '总名单数',
    title2: '平均拨打次数',
    title3: '平均流转action数',
    title4: 'OutBound拨打次数',
    title5: '接通数',
    title6: '接通率',
    title7: '短信发送数',
    title8: '点击数（7天内）',
    title9: '点击率（7天内）',
    title10: 'WA发送数',
    title11: 'PDS拨打名单数'
  },
  channel: {
    tableTitle: '模板列表',
    name: '模板名称',
    content: '信息内容',
    str: '信息字符',
    num: '信息条数',
    channel: '发送渠道',
    conventional: '常规机器人',
    diy: '自定义IVR机器人',
    change: '更换音色',
    record: '音色',
    speed: '播报速度',
    contentTip: '①短信内容中若存在链接，会在发送时为您转换为专用短链，可统计用户的点击情况；②短信内容中若存在样式为{xxx}的内容，是模板中的变量，会根据您上传的变量内容给不同的用户发送不同的内容。',
    strTip: '此处为预计字符，根据信息中链接或变量的实际内容不同，字符数也会不同。',
    sendTime: '发送时间',
    templateName: '短信模版'
  },
  eventLabel: {
    label: '事件标签',
    attr: '标签属性',
    drawerTitle: '事件标签说明',
    all: '全部信息',
    more: '更多'
  },
  checkDetail: {
    ringTime: '响铃时长',
    totalNumberCalls: '总呼叫次数',
    callHistory: '呼叫记录',
    questionNumber: '问题序号',
    problemDesc: '问题描述',
    topic: '题型',
    whetherAnswer: '是否回答',
    answer: '答案',
    variable: '变量',
    checkResults: '核验结果',
    checkDialogue: '查看对话',
    previousDetail: '上一详情',
    nextDetail: '下一详情',
    history: '历史记录',
    know: '知道了',
    clickDesc: '点击查看详情，了解更多通话内容',
    whether: '是否题',
    multiple: '选择题',
    open: '开放题'
  },
  report: {
    titleTip: '（仅支持查看{name}后产生的数据）',
    time: '时间段',
    compared: '对比',
    deduplication: '是否去重',
    listNum: '总名单数',
    connectNum: '接通数',
    connectRate: '接通率',
    duration: '平均通话时长（秒）',
    business: '业务数据',
    robot: '机器人表现',
    turn: '接通情况',
    beforeOverdue: '逾期前',
    todayOverdue: '到期当日',
    overdue: '逾期后',
    labelRate: '标签率',
    month: '按月',
    week: '按周',
    onWeek: '第{name}周',
    unduplicated: '去重',
    duplicate: '不去重',
    labelTip1: '统计周期内，已上传的总名单数',
    labelTip2: '统计周期内，已接通的总名单数',
    labelTip3: '统计周期内，已拨打名单的接通率',
    labelTip4: '统计周期内，已接通名单的平均通话时长',
    type: '类别'
  },
  version: {
    viewarchive: '查看归档',
    archive: '归档',
    id: '版本号',
    description: '版本描述',
    templateId: '模版ID',
    save1: '迭代发布',
    save2: '发布成新版本',
    save3: '启用此版本',
    save4: '不启用此版本',
    saveTip: '开启后，该版本将会替换目前正在启用中的版本',
    draft: '草稿',
    time: '归档时间',
    re: '还原',
    user: '归档人',
    pdsQA: '自动QA',
    success: '启用成功',
    resuccess: '还原成功',
    delsuccess: '归档成功',
    savesuccess: '保存成功',
    pop: '该版本已发布，将基于该版本创建草稿',
    version: '版本',
    listTime: '名单上传时间'
  },
  experience: {
    robotNameTip: '请输入机器人名字',
    shareLog: '分享记录',
    shareBatch: '批量分享',
    playAudio: '播放录音',
    experience: '立刻体验',
    share: '立刻分享',
    step1: '请填写基础信息',
    step2: '设置场景和机器人',
    step3: '配置变量',
    step4: '完成',
    shareNmae: '分享名',
    language: '界面语言',
    validity: '有效期',
    callCountry: '拨打国家',
    shareTime: '过期时间',
    zh: '中文',
    en: '英文',
    ba: '印尼语',
    copyLink: '复制链接',
    qrcode: '查看二维码',
    view: '查看数据',
    disable: '置为失效',
    linkLog: '链接浏览记录',
    customerLog: '客户体验记录',
    check: '查看明细',
    logTime: '浏览时间',
    browser: '浏览器',
    device: '设备',
    city: '城市',
    isExperience: '是否体验',
    shareTitle: '分享',
    dec: '机器人描述',
    enterShare: '确定分享',
    noVar: '此机器人无变量需配置',
    callNumber: '手机号码',
    waitCall: '请稍等片刻，电话即将呼出',
    reCall: '电话重拨',
    activeSuccess: '置为失效成功',
    ruleName: '请输入分享名',
    ruleLanguage: '请选择界面语言',
    ruleTime: '请选择有效期',
    ruleCounty: '请选择拨打国家',
    ruleDesc: '请输入机器人描述',
    fail: '当前链接已失效，请联系分享者',
    sceneName: '场景名',
    sceneDesc: '场景描述',
    canModify: '客户可修改',
    calltitle: '填写信息',
    successTitle: '提交成功',
    wait: '请稍等',
    waitNext: '电话将很快拨出',
    cut: '拆分该场景机器人',
    cutTip: '若需要将多个机器人组合为一个场景进行分享，请拖拽机器人至同一场景内',
    codeTip1: '扫一扫体验智能语音机器人',
    codeTip2: '该二维码将于{time}失效',
    downCode: '下载二维码',
    tips: '是否确定置为失效？',
    tempDesc: '描述语模版',
    sceneRepeat: '场景名重复',
    callTime: '拨打时间',
    otherRob: '其他机器人',
    failTime: '失效时间',
    gender: '音色'
  },
  // 私有化版本相关功能
  v_privatization: {
    templateContent: '模板内容',
    insertUrl: '插入Target URL',
    templatePlaceholder: '请输入模板名称',
    templateContentPlaceholder: '请输入模板内容',
    channelPlaceholder: '请选择发送渠道',
    SMSTemplate: '短信模板',
    WhatsAppTemplate: 'WhatsApp 模板',
    createSMSTemplate: '新增短信模板',
    editSMSTemplate: '编辑短信模板',
    createWhatsAppTemplate: '新增 WhatsApp 模板',
    editWhatsAppTemplate: '编辑 WhatsApp 模板',
    SMSTip:
      '说明：输入Original URL后，点击“插入Target URL”可在实际发送短信时将链接插入短信内容中，且Target URL为实际发送给用户的短链，通过此方式发送短信可以统计链接的点击情况。短信字数和条数统计为估算，具体字数请自行测试。',
    WhatsAPPTip:
      '说明：输入Original URL后，点击“插入Target URL”可在实际发送信息时将链接插入信息内容中，且Target URL为实际发送给用户的短链，通过此方式发送信息可以统计链接的点击情况。信息字数和条数统计为估算，具体字数请自行测试。',
    hangUpMessage: '挂机信息',
    hangUpMessageAdd: '添加挂机信息',
    hangUpMessageEdit: '编辑挂机信息',
    hangUpMessageTip: '开启多轮任务短信发送策略，下一轮还会拨打的名单在当前轮不再发送短信',
    callResult: '通话结果',
    messageType: '信息类型',
    messageTemplate: '信息模板',
    messageChannel: '信息渠道',
    messageNumber: '发送条数',
    messageTip: '①短信内容中的短链可统计用户的点击量；②短信内容中若存在样式为{xxx}的内容，是模板中的变量，会根据您上传的变量内容给不同的用户发送不同的内容。',
    channel: '渠道',
    platformPlaceholder: '请选择 Platform',
    addMessage: '添加信息模板',
    activeStatusTip: '是否确认启用该模板？',
    inactiveStatusTip: '是否确认禁用该模板？',
    activeHangUpStatusTip: '是否确认启用该挂机短信？',
    inactiveHangUpStatusTip: '是否确认禁用该挂机短信？',
    operateSuccess: '操作成功',
    licenseValidityPeriod: 'License有效期',
    maxCallConcurrency: '调度并发限制',
    LicenseTip: 'License过期提示',
    licenseWillExpired: '',
    licenseExpired: '',
    licenseInvalid: 'License已过期，无法继续使用。'
  },
  calendar: {
    title: '日历管理',
    lab1: '节日列表',
    lab2: '日历分布',
    type: '分类',
    dayName: '节日名称',
    addDay: '添加自定义节日',
    day1: '工作日',
    day2: '休息日',
    day3: '法定节假日',
    day4: '自定义节日',
    tip: '判断逻辑：名单进入该节点时或账户时区每日05:00判断该日是否放行，判定不放行后，第二天05:00再次判断，直至当日满足放行条件，名单才会继续进入后续流程',
    r1: '使用原任务机器人',
    r2: '选择机器人'
  },
  inbound: {
    callDimension: '通话维度',
    knwlDimension: '知识点维度',
    screeningConditions: '筛选条件',
    talkedByRobots: '总通话量',
    talkingByRobots: '机器人通话中数',
    stRate: '人工接待率',
    stTip: '成功转人工的通话/总通话量',
    raTalkTime: '机器人平均通话时长',
    raTalkRounds: '机器人平均交互轮次',
    tbAgents: '人工通话量',
    tbTip: '成功转人工的通话量',
    tbAgents2: '人工通话中数',
    attAgentNum: '尝试转人工数',
    tttRate: '尝试转人工率',
    tttTip: '尝试转人工的通话/总通话量',
    tatTime: '总平均通话时长',
    tatTip: '机器人与用户+人工与用户的平均通话时长',
    tickets: '工单创建数',
    graphics: '图表',
    prceProcess: '机器人各流程通话量占比',
    transRate: '通话量及转人工率趋势',
    calls: '通话数量',
    rate: '比例',
    allProcess: '全部流程',
    rlDistribution: '机器人标签分布',
    dtReason: '转人工原因分布',
    dtNodes: '转人工节点分布',
    kwnlPoint: '知识命中率',
    hitValid: '命中有效知识数',
    useRate: '知识的利用率',
    knRoundNum: '知识命中对话轮次',
    allRoundNum: '总对话轮次',
    hitRate: '知识命中率',
    validPer: '有效知识占比',
    top10: 'Top10热门知识',
    top20: 'Top20冷门知识',
    knName: '知识点名称',
    mainProcess: '主流程',
    hotline: '热线',
    inbound: '呼入',
    inAndOut: '呼入+呼出',
    satisRating: '满意度评分分布',
    userSatis: '用户满意度',
    star1: '1星',
    star2: '2星',
    star3: '3星',
    star4: '4星',
    star5: '5星',
    satisRate: '满意度',
    userNum: '用户数',
    robotOneTimeRate: '机器人一次性解决率',
    rotTip: '当日未二次来电的有效通话/有效通话量',
    comeTeleUserNum: '来电用户数',
    ctuTip: '来电的用户中按照呼入号码去重的数量',
    effectTeleUserNum: '有效用户数',
    etuTip: '机器人与用户至少有一轮有效交互的通话总共来自于多少用户，按照用户的呼入号码去重',
    totalEffectCallNum: '总有效通话量',
    noSecondCallNum: '用户未二次来电的有效通话量',
    oneTimeRate: '一次性解决率',
    toArtiRate: '转人工成功率',
    taiTip: '转人工成功的通话/尝试转人工的通话量',
    robotJudgeRate: '机器人评价率',
    rjTip: '已触发满意度评价的通话中已评分的通话占比',
    robotAvgScore: '机器人满意度平均分',
    raTip: '所有通话的满意度评分均值',
    effectCallNum: '有效通话量',
    ecnTip: '总通话中，机器人与用户至少有一轮有效交互的通话数',
    reCallRate: '重复来电率',
    rcrTip: '（通话数-去重用户数）/去重用户数',
    taTip: '成功转人工的通话占尝试转人工的通话占比',
    ecTip: '至少有一轮有效交互的通话数',
    ctTip: '按呼入号码去重的用户数',
    euTip: '至少有一轮有效交互的去重用户数',
    rcTip: '多次来电的用户比例',
    orTip: '用户未二次来电的有效通话占比',
    orTip2: '用户未二次来电的有效通话占比（此处是T+1天数据，统计的是每个自然日的一次性解决率）',
    userTip: '此处是T+1天数据，统计的是每个自然日的来电用户数和有效用户数',
    oneRateTip: '此处是T+1天数据',
    realtimeData: '实时数据',
    offlineData: '离线数据',
    robotSatis: '机器人满意率',
    rsTip: '所有已评价的通话中评价为“满意”的通话占比',
    robotSatisTip: '筛选时间段内，所有已评价的通话中评价为“满意”的通话占比',
    everydayMax: '每日最大并发',
    dataOutput: '数据导出',
    attemptAgentNum: '尝试转人工通话量',
    robotJudgeNum: '机器人评价数',
    robotSatisNum: '机器人满意数',
    thisDayNoBack: '当日未二次来电的有效通话',
    thisDayMax: '当日最大并发数',
    showAndDlField: '展示及下载字段',
    allCountry: '全部国家',
    intentAccuracy: '意图识别准确率',
    untriggered: '未触发',
    unrated: '未评价',
    robotSatisRate: '机器人满意度评分',
    indicators: '指标',
    labelPriority: '标签优先级',
    dlData: '下载数据'
  },
  chatbot: {
    reason: '原因',
    indicator: '仪表盘',
    graphics: '数据可视化',
    social: '社媒',
    allSocial: '所有社媒',
    allCountry: '所有国家',
    sessionData: '会话数据',
    resTime: '响应时长',
    today: '今日',
    yesterday: '昨日',
    robotSessionNum: '机器人会话数',
    satisRate: '满意度',
    likeFWRate: '服务满意度',
    robotEnd: '机器人结束',
    botQueueTimeout: '机器人排队超时',
    userEnd: '用户结束',
    agentEnd: '人工结束',
    robotChatCondition: '机器人对话情况',
    sessionEndReason: '会话结束原因',
    intentionDistribution: '服务流程触发分布',
    identifyDistribution: '识别分布',
    knowledgeBase: '知识库',
    intention: '意图',
    chat: '闲聊',
    unrecognized: '未识别',
    robotCondition: '机器人识别情况',
    top10: 'Top10热门知识',
    words: '话术',
    knowledgePoints: '知识点',
    triggerRate: '触发量/比例',
    star1: '1星',
    starVal: '{num}星',
    userNum: '用户数',
    sessionNum: '会话数',
    repeatRate: '重复进线率',
    repeatRate2: '当日重复进线率',
    userNews: '用户消息数',
    robotTimes: '机器人响应时长',
    robotBFNum: '实时机器人并发量',
    artificialNum: '转人工会话数',
    robotWaitNum: '机器人排队数',
    artificialWaitNum: '人工排队数',
    artificialCalls: '人工响应时长',
    callsAvg: '平均响应时长',
    sessionAvg: '平均会话时长',
    robotSessionAvg: '机器人平均会话时长',
    artificialRate: '转人工率',
    robotEndNum: '机器人结束会话数',
    userEndNum: '用户结束会话数',
    artificialEndNum: '坐席结束会话数',
    roundAvg: '平均对话轮次',
    robotLikes: '机器人满意度',
    JSRate: '拒识率',
    knowledgeNum: '知识数',
    intentionNum: '意图数',
    chatNum: '闲聊数',
    unrecognizedNum: '未识别数',
    recognizedNum: '直接识别率',
    recommendRate: '推荐问触发率',
    vsday: '前1日',
    vsday7: '前7日',
    detailExport: '详细数据导出',
    total: '总计',
    date: '日期',
    country: '国家',
    channel: '渠道',
    download: '下载',
    userLikes: '用户满意度',
    coreData: '核心业务数据',
    likeRate: '满意率',
    evaluateRate: '评价率',
    serverLikeRate: '服务满意率',
    robotLikeRate: '机器人满意率',
    robotEvaluateRate: '机器人评价率',
    artificialSuccessRate: '转人工成功率',
    serverEvaluateRate: '服务评价率',
    todayMaxBFNum: '当日最大并发量',
    likeNum: '满意数',
    firstSolutionRate: '首解率',
    artificialOkSessions: '转人工成功会话数',
    todayZXYDNum: '当日咨询运单数',
    ZXYDNum24: '24h无二次咨询运单数',
    userLikeNum: '满意用户数',
    evalUsers: '评价用户数',
    robotEvaluates: '机器人评价数',
    robotLikeNum: '机器人满意数',
    userServerEvaluates: '人工服务评价数',
    userServerEvaluateRate: '人工服务评价率',
    userServerLikeRate: '人工服务满意率',
    userServerLikes: '人工服务满意数',
    artificialFailNum: '转人工失败会话数',
    artificialFailEvaluates: '转人工失败评价数',
    artificialFailLikes: '转人工失败满意数',
    artificialFailEvaluateRate: '转人工失败评价率',
    artificialLikeRate: '转人工满意率',
    artificialFailLikeRate: '转人工失败满意率',
    all: '全部',
    likeRateAnalysis: '满意度分析',
    serverEffect: '服务效果',
    dislikeDistribution: '不满意原因分布',
    sessionType: '会话类型',
    robotSession: '机器人会话',
    artificialSuccess: '转人工成功',
    artificialFail: '转人工失败',
    artificialSession: '转人工会话',
    botServerSession: '机器人服务会话',
    artificialOkSession: '转人工成功会话',
    artificialFailSession: '转人工失败会话',
    evaluates: '评价数',
    channelMerge: '渠道聚合',
    current_users_total: '当前处理会话数',
    current_robot_wait: '当前机器人排队会话数',
    current_agent_sessions: '当前坐席处理会话数',
    current_robot_sessions: '当前机器人处理会话数',
    current_agent_wait_sessions: '当前坐席排队会话数',
    users: '用户数',
    sessions: '会话数',
    rr_income: '当日重复进线率',
    user_messages: '用户消息数',
    robot_res_time: '机器人响应时长',
    transfers: '转人工会话数',
    transfer_rate: '转人工率',
    transfers_succeed_rate: '转人工成功率',
    avg_sessions_time: '平均会话总时长',
    avg_robot_time: '平均机器人会话时长',
    avg_agent_time: '平均人工会话时长',
    // avg_trans_time: '转人工等待时长',
    max_qps: '当日最大并发量',
    Knowledge: '知识库',
    All: '意图',
    NoRecognize: '未识别',
    user_close: '用户结束',
    robot_close: '机器人结束',
    agent_close: '人工结束',
    ascending: '从低到高排序',
    descending: '从高到低排序',
    etip1: '将您关注的指标拖入相关预览框中',
    etip2: '会话结束原因',
    etip3: '数据指标已添加完成',
    etip4: '暂无更多指标',
    etip5: '图表已添加完成',
    etip6: '暂无更多图表',
    etip7: '当前页面编辑信息未保存,是否保存？',
    title1: '实时指标',
    title2: '当天累计指标',
    title3: '数据图表',
    title4: '机器人识别分布',
    title5: '会话结束原因',
    title6: '趋势图',
    title7: '意图分布',
    avg_trans_time: '平均转人工等待时长',
    botSessionNum: '机器人会话数',
    agentSessions: '转人工会话数',

    story: {
      story_PlaceOrder: '寄快递',
      story_DeliveryAsk: '快件催查',
      story_Package_returned: '快件退回',
      story_Change_Information: '修改信息',
      story_AskShippingCost2: '查运费',
      sotry_AskEstimatedTimeBeforeDelivery: '查时效',
      story_AskBranch: '查网点',
      story_AskDelivery_Range: '查配送范围',
      story_PackageIssues: '快件问题',
      story_AskFranchise: '加盟咨询',
      story_TransferArtificial: '人工服务',
      story_Complaint: '投诉'
    },
    userID: '用户ID',
    userName: '用户昵称',
    localTime: '当地时间',
    sessionStartTime: '会话开始时间',
    robotServiceTime: '机器人服务时长',
    agentServiceTime: '人工服务时长',
    waybill: '合法运单号',
    sessionEndTime: '会话结束时间',
    sessionDur: '会话时长',
    serverStatus: '服务状态',
    robotServer: '机器人服务',
    userServer: '人工服务',
    noLikeReason: '不满意原因',
    sessionDetail: '会话详情',
    prevOne: '上一个',
    nextOne: '下一个',
    cannelTitle: '添加消息渠道，与您的用户高效沟通。',
    noChannel: '无授权渠道',
    addCannnel: '添加渠道',
    delete: '删除',
    edit: '编辑',
    detail: '详情',
    duplicate: '复制',
    action: '操作',
    addTime: '添加时间',
    updateTime: '更新时间',
    updater: '更新人',
    accountName: '账号名称',
    dialogueLink: '对话链接',
    last: '上一步',
    next: '下一步',
    next2: '已拥有，下一步',
    authorize: '授权账号',
    stepVal: '步骤{num}',
    viberPanel: 'Viber Bot控制面板',
    almost: '即将完成',
    addBind: '新增绑定',
    editBind: '修改绑定',
    effectChannel: '生效渠道',
    robotId: '机器人ID',
    versionId: '版本ID',
    channelName: '渠道名称',
    channelId: '渠道ID',
    updateAccount: '更新账号',
    seeRecord: '查看记录',
    save: '保存',
    cancel: '取消',
    submit: '提交',
    remark: '备注',
    facebookBtn: '关联Facebook',
    connectChannel: '授权渠道',
    newInf: '新增信息',
    editInf: '编辑信息',
    name: '名称',
    company: '公司',
    proxy: '代理',
    reqName: '请求名称',
    tmplName: '模版名称',
    saveDraft: '保存为草稿',
    saveSubmit: '保存并提交',
    wbTmplStatus: {
      draft: '草稿',
      rejected: '审核不通过',
      submitted: '审核中',
      approved: '审核通过'
    },
    broadcastList: '广播列表',
    broadcastName: '广播名称',
    sendAccount: '发送账号',
    broadcastTmpl: '广播模版',
    newBroadcast: '新建广播',
    broadcastDetail: '广播详情',
    broadcastData: '广播数据',
    taskList: '任务列表',
    tmplInf: '模版信息',
    copyTask: '复制任务',
    broadcastTime: '广播时间',
    selectTmpl: '选择模版',
    upContacts: '上传名单',
    setTime: '设定时间',
    taskStatus: {
      failed: '发送失败',
      wait: '未发送',
      sending: '发送中',
      sent: '已发送',
      delivery: '已送达',
      read: '已阅读',
      replied: '已回复'
    },
    taskNum: '名单量',
    sentNum: '发送量',
    deliveredNum: '送达量',
    readNum: '阅读量',
    replies: '回复量',
    failNum: '失败量',
    deliveredRate: '送达率',
    readRate: '阅读率',
    replyRate: '回复率',
    sendNow: '立即发送',
    sendSchedule: '预约发送',
    sendTime: '发送时间',
    account: '账号',
    downloadTmpl: '下载模版',
    reupload: '重新上传',
    sendResults: '发送结果',
    broadcastStatus: '广播状态',
    userAccount: '用户账号',
    userOptOut: '用户退订',
    batchAdd: '批量添加',
    seatMark: '坐席标注',
    addNameLs: '添加名单',
    moreDetails: '更多详情',
    optOutStartTime: 'Opt-out开始日期',
    optOutEndTime: 'Opt-out结束日期',
    remove: '移除',
    tip: {
      userNum: '进线的用户去重总数',
      sessionNum: '用户创建的会话总数',
      repeatRate: '单日单用户的非首次会话总数/所有会话总数',
      userNews: '用户发送的总消息数',
      robotTimes: '机器人服务的会话，平均单次回复运行时长',
      robotBFNum: '当前与机器人会话的客户总量',
      artificialNum: '由机器人转接人工的会话数',
      artificialRate: '转人工的会话数/会话数',
      robotWaitNum: '排队等待机器人服务的会话数',
      artificialWaitNum: '排队等待人工服务的会话数',
      artificialCalls: '人工服务的会话，平均单次回复运行时长',
      callsAvg: '平均单次回复运行时长',
      sessionAvg: '所有会话的平均分钟数',
      robotEndNum: '由机器人告知会话结束',
      userEndNum: '由用户行为结束对话（按钮/策略）',
      artificialEndNum: '由坐席结束对话',
      roundAvg: '机器人与用户平均在每个会话中对话的轮次',
      JSRate: '机器人未识别的用户消息比例',
      recognizedNum: '机器人识别出用户意图的消息数',
      recommendRate: '触发机器人推荐问，用户意图澄清的消息数',
      knowledgeNum: '机器人回复中，命中知识库的数量',
      intentionNum: '机器人回复中，命中意图识别的数量',
      chatNum: '机器人回复中，命中闲聊的数量',
      unrecognizedNum: '机器人未识别用户发送信息的数量',
      robotSessionAvg: '由机器人服务的会话的平均会话时长',
      firstSolutionRate: '查询该运单后，24小时内无重复进线的运单比例',
      todayMaxBFNum: '查询日期的机器人最大并发量',
      serverLikeRate: '所有会话中，满意的会话/有评价的会话',
      serverEvaluateRate: '有评价的会话/所有会话',
      artificialSuccessRate: '转人工成功的会话数/转人工会话数',
      robotLikeRate: '机器人服务会话中，满意的会话/有评价的会话。',
      artificialLikeRate: '机器人转人工的会话中，满意的会话/有评价的会话。',
      userServerLikeRate: '人工服务的会话中，满意的会话/有评价的会话。',
      artificialFailLikeRate: '转人工失败的会话中，满意的会话/有评价的会话。',
      channelMerge: '开启后将展示所有渠道的聚合数据，关闭查看各渠道明细数据。',
      plsDayVal: '最多可查询{num}天',
      plsFutureDayVal: '请选择未来{num}天内的时间',
      noChannel: '您可以在我们的平台上连接所有的业务消息账户，我们称之为渠道。让我们一起来添加一个渠道吧。',
      facebookTitle: '我们需要一些权限来管理您的主页消息，以便能收到和回复Messenger消息与评论',
      facebookStep1: '基于Facebook封号规则，请在经常登录Facebook账号的电脑上进行授权绑定',
      facebookStep1_des: '授权前，请确保您必须是Facebook粉丝主页的管理员',
      facebookStep2: '若提示错误，请检查网络是否正常，剧新页面后重试',
      facebookStep3: '登录您的Facebook帐户并勾选您想要授权管理的粉丝主页',
      insTitle: '请确保您拥有Instagram专业账号',
      insStep1_1: '您需要将Instagram个人账号转换为专业账号才能连接至AI Rudder',
      insStep1_2: '如需帮助，请参考:',
      insStep1_3: '在Instagram上设置专业账号',
      whatsappStep1: '未注册WhatsApp的手机号，且该手机号可接收短信或电话',
      whatsappStep2: '经过认证的Facebook Business Manager',
      lineTitle: '请在同一Provides下创建Line的Messaging API channel, 然后提供以下信息完成Line账号添加',
      botTokenProvide: '请提供在 {name} 处获取到Bot Token完成授权',
      authorizeSuccess: '授权成功',
      authorizeFail: '授权失败',
      delChannel: '如果您解除此渠道授权，您将无法再通过此渠道与联系人互动。您确定要一起解除授权吗？',
      repeatChannel: '您已在平台授权此账号，请重新选择',
      plsTelMe: '请联系我们获得帮助',
      plsScopeFacebook: '请授权Facebook账号',
      upload: '允许{types}类型的文件上传, 且文件的大小不超过{size}.',
      uploadSize: '文件的大小不能超过{size}',
      tmplNameReg: '请输入小写字母数字或下划线',
      noLikePlsClick: '没有合适的？点击{name}',
      broadcastSaveErr: '表格内第{n}行用户信息有误，请重新上传',
      broadcastSaveRepeat: '第{n}行用户信息重复，请查看后重新上传',
      broadcastSaveOverload: '上传的用户超过单次广播数量上限，请重新上传',
      broadcastDelTask: '删除后，任务不可恢复，确认要删除吗？',
      broadcastLimtNum: '当前账号{name}，发送限制为：{n}/24小时，超出限制的会发送失败。',
      broadcastDLTitle: '下载本广播名单样例',
      broadcastDLTip1: '请填写每个用户的变量信息，缺失的将填写默认值。',
      broadcastDLTip2: '仅允许上传xlsx/csv类型的文件，且不超过1MB。单次任务至多上传3000人。',
      broadcastReplies: '发送成功后，24h内有回复消息的用户数量',
      removeOptOut: '移出后，用户将收到广播消息，请确认移出。',
      optOutTerm: '说明：用户90天内将不会收到广播消息',
      batchTelUp: '支持批量上传，号码间需要换行<br>示例：<br>+628122218888888<br>+628122217777777',
      avg_sessions_time: '用户进线时间到会话结束时间',
      avg_robot_time: '机器人开始时间到发起转人工时间',
      avg_agent_time: '成功转人工时间到人工结束对话时间',
      avg_trans_time: '发起转人工时间到成功转人工时间',
      current_users_total: '当前正在处理或等待处理、未关闭的会话数',
      current_robot_wait: '当前等待机器人处理的会话数',
      current_agent_sessions: '当前坐席正在处理、未关闭的会话数',
      current_robot_sessions: '当前机器人正在处理、 未关闭的会话数',
      current_agent_wait_sessions: '当前发起转人工未成功转接、正在排队的会话数'
    },
    wbTmplTip: {
      header: '添加标题或选择此Header所使用的媒体类型',
      body: '如果要添加自定义变量，请在{{}}中添加一个变量，不要加空格。',
      body2: '如：{{name}}',
      footer: '在模板消息底部添加一行简短的文本',
      buttons: '添加快捷回复或CTA按钮',
      buttonLimit: 'Buttons不能有变量、换行符或表情符号',
      variables: '请确保不要包含任何实际的用户或客户信息，并且在示例中只提供示例内容。',
      sample: 'Sample content for {name}',
      del: '删除模板后，30天内不可申请同名模板，请确认是否删除？',
      variableRepeat: '变量名不能重复',
      optOutBtn: '用户退订入口，如用户点击90天内将不会收到广播'
    }
  },
  teamInbox: {
    // 新增
    all_chat: '所有',
    my_chat: '我的',
    manuanling: '未分配',
    broadcast: '广播',
    bot: '机器人',
    closed: '关闭',
    broadcastinfo: '广播会话',
    botinfo: '机器人会话',
    broadcastType: '未开启',
    botType: 'bot',
    manuanlingType: '未分配',
    manualedType: '与{user}交谈中',
    closedType: '已关闭',
    jiesu: '结束会话',
    jieg: '接管会话',
    userInfo: '客户信息',
    chatTitle: '坐席会话',
    manualedAMType: '转交',
    duihua: '对话中',
    changeUser: '确认将对话转交给:',
    tips: '提示',
    yes: '是',
    no: '否',
    noType: '暂不支持展示该类型消息',
    start: '{name}开启了新的会话',
    close: '{name}关闭了会话',
    take_over: '{name}接管了会话',
    hand_over: '{name}将会话转交{toName}',
    msgSet: '消息设置'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js